/* eslint-disable camelcase */
import React, {ReactElement, useEffect, useState} from 'react';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import {useSnackbar} from 'notistack';
// TODO: INSTEAD OF USING MATERIAL UI COMPONENTS DIRECTLY, CREATE GENERIC COMPONENTS IN SYSTEM AND IMPORT IT
import {
  Button,
  Radio,
  ClickAwayListener,
  createStyles,
  Divider,
  IconButton,
  ListItemText,
  makeStyles,
  MenuItem,
  MenuList,
  Popper,
  Select,
  Tooltip,
  Typography,
  Link
} from '@material-ui/core';
import {connect, useDispatch, useSelector} from 'react-redux';
import {useTranslation, Trans} from 'react-i18next';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ErrorIcon from '@material-ui/icons/Error';
import EmailIcon from '@material-ui/icons/Email';
// import ShareIcon from '@material-ui/icons/Share';
import SmsIcon from '@material-ui/icons/Sms';
import MessageIcon from '@material-ui/icons/Message';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
import HelpIcon from '@material-ui/icons/Help';

// components
import SearchField from '@components/system/search/SearchField';
import CustomSelectField from '../../ClinicGroups/AddUser/CustomSelectField';
// import DateInput from '@components/system/DateInput/DateInput';
import {
  getAllClinics,
  getClinicGroupsDetails
} from '@shared/services/ClinicServices';
import {
  _guarantorLogin,
  _saveClinicDetails,
  _guarantorPayAmount,
  _guarantorPayCashAmount,
  _updatePaymentType,
  _setPayInInstallmentDetails,
  _resetPaymentsReducer
} from '@shared/store/actions/PaymentActions';
import {
  _statementsSelectedClinic,
  _clinicNotificationBatchIds,
  _setClinics
} from '@shared/store/actions/ClinicActions';
import {
  downloadDueInvoices,
  fetchDueInvoices,
  fetchDueInvoicesPatientCount,
  fetchGuarantorsInvoiceNotificationDetails,
  getAllReminders,
  // invoiceDetails,
  scheduleReminders,
  sendReminders,
  updateGuarantorDueNoticeType
} from '@shared/services/DueInvoiceServices';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import DownArrowIcon from '@components/system/MyIcons/DownArrowIcon';
import UpArrowIcon from '@components/system/MyIcons/UpArrowIcon';

// styles and variables
import './DueInvoicesStyles.scss';
import {
  APP,
  BORDER_PRIMARY_COLOR,
  DEFAULT_BLACK_COLOR,
  FONT_TERTIARY_COLOR
} from 'src/style/variable';

// table cells, headers, table box shadow, border, background styles
import {
  // fixedCellwidth80,
  GuarantorCellStyle,
  GuarantorHeaderStyle,
  tableCellWidth12,
  phoneNumberWidth,
  tableCellWidth8
  // tableCellWidth18
} from '../TableStyles';
// import DrawerComponent from '../Drawer/DrawerComponent';
import RemainderHistory from '@components/system/MyIcons/RemainderHistory';
// import CustomPopper from '../../../../../components/system/CustomPopper/CustomPopper';
// import ScheduleSendIcon from '@components/system/MyIcons/ScheduleSendIcon';

// table data
import {textFieldStyles} from '../TableDataAndStyles';
import CustomDateTimePicker from './CustomDateTimePicker/CustomDateTimePicker';
import Loader from '@components/framework/loader/Loader';
import ImportLoader from '@components/system/ImportLoader/ImportLoader';
import CurrencyFormatter, {
  getFormattedValue
} from '@components/system/CurrencyFormatter/CurrencyFormatter';
import InvoiceImportErrorTable from './InvoicesImportError/InvoiceImportErrorTable';
import {
  getImportErrorData,
  getImportSummaryImportIds
} from '@shared/services/CommonServices';
import GridTable, {
  DEFAULT_GRID_TABLE__OPTIONS
} from '@components/system/GridTable/GridTable';
import {
  PAGINATION_SIZE,
  PAGINATION_SIZE_OPTIONS
} from '../../../../../constants/SystemConstants';
import GuarantorDrawerComponent from '../Drawer/GuarantorDrawerComponent';
import ConfirmationDialog from '@components/system/ConfirmationDialog/ConfirmationDialog';
import {
  AppPermissions,
  AppSmsStatus,
  ImportSummaryTypes,
  NotificationType,
  SEARCH_DEBOUNCE_DELAY,
  StatementNoticeType,
  PaymentTypes,
  IMPORT_TYPES,
  CUSTOM_NOTIFICATION_TYPES,
  EMRProviderIDs,
  SendCustomMessageTypes
} from '@shared/constants/Mapping';
import CustomPopOver, {
  CustomPopOverListItemType
} from '@components/system/CustomPopOver/CustomPopOver';
import HelperUtils, {
  formOptedOutNotificationLabel
} from '@shared/utils/HelperUtils';
import {useDebouncedCallback} from 'use-debounce';
import theme from 'src/materialtheme';

import {Permission} from '@shared/services/PermissionService';
import CardPayDialog from '../../../../../components/system/CardPayDialog/CardPayDialog';
import ChangePhoneDialog from './ChangePhoneDialog/ChangePhoneDialog';
import SharePaymentDialog from './SendEmailStatement/SharePaymentDialog';
import ImportFileDialog from '../../Common/ImportDialog';
import MakeSettleStatement from './MakeSettleStatement';
import PatientStatementsFilterComponent from './CompactView/PatientStatementsFilterComponent';
import ButtonField from '@components/system/ButtonField/ButtonField';
import CheckBoxField from '@components/system/CheckBox/CheckBoxField';
import ButtonLoader from '@components/system/ButtonLoader/ButtonLoader';
import HelperTexts from '../HelperTexts/HelpertTexts';
import CheckStatements from '../CheckStatements/CheckStatements';
import CustomMessageDialog from '../../Common/CustomMessageDialog';
import {getLastMessage} from '@shared/services/MessageService';
import {BATCH_ID_DATE_FORMAT} from '@shared/utils/DateTimeUtils';
import MessagesConversationDialog from '../../Sms/components/MessagesConversationDialog/MessagesConversationDialog';
// import {_patientDrawerDetails} from '@shared/store/actions/PatientDrawerAction';
import PhoneNumberFormatter from '@components/system/PhoneNumberFormatter/PhoneNumberFormatter';
import GuarantorInvoicesTable from './GuarantorInvoicesTable/GuarantorInvoicesTable';
import {axios, CancelTokenSource} from '@shared/axios';
import CCMShowFullNotesDialog from '../../ChronicCareManagement/module-components/CCMShowFullNotesDialog/CCMShowFullNotesDialog';
// import {_ccmSinglePatientDetails} from '@shared/store/actions/CCMTimerActions';

// const emailLabel = makeStyles(() =>
//   createStyles({
//     icons: {
//       cursor: 'pointer',
//       fontSize: '0.8rem'
//     },
//     actionIcons: {
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       margin: '0 3px',
//       textAlign: 'center'
//     }
//   })
// );

const remainderPopper = makeStyles(() =>
  createStyles({
    menuList: {
      maxHeight: '100px',
      overflow: 'auto',
      outline: 'none'
    },
    menuItems: {
      padding: '0.5rem 0.7rem 1rem 0.7rem',
      outline: 'none',
      display: 'flex',
      alignItems: 'center'
    },
    menuItemsSerial: {},
    dataWrap: {
      display: 'flex',
      alignItems: 'center'
    },
    typeWrap: {
      paddingLeft: '0.5em'
    },
    dateWrap: {
      paddingLeft: '0.5em'
    },
    iconWrap: {
      paddingLeft: '0.75em'
    },
    textWrap: {
      color: APP.STATUS.ERROR,
      fontStyle: 'italic',
      paddingLeft: '0.5em'
    },
    header: {
      fontSize: '1rem',
      padding: '1rem 0.7rem',
      fontWeight: 'bold'
    },
    subTitle: {
      fontSize: '1rem',
      padding: '0.5rem 0.7rem'
    },
    notificationReminder: {
      marginTop: '-4px',
      marginLeft: '0.5rem'
    },
    notificationView: {
      display: 'flex',
      flexDirection: 'row',
      lineHeight: '1rem',
      alignItems: 'flex-start',
      justifyContent: 'center'
    }
  })
);

const cardStyle = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      margin: '16px 6px',
      width: '100%',
      marginLeft: '-8px'
    },
    wrapper: {
      width: '100%',
      margin: '0 8px',
      padding: '12px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      border: `1px solid ${BORDER_PRIMARY_COLOR}`,
      borderRadius: '5px'
    },
    wrapperLast: {
      width: '100%',
      margin: '0 -8px 0 8px',
      padding: '12px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      border: `1px solid ${BORDER_PRIMARY_COLOR}`,
      borderRadius: '5px'
    },
    cards: {
      fontSize: '0.875rem'
    },
    cardsVal: {
      fontSize: '1.125rem',
      fontWeight: 700
    },
    buttonWidth: {
      '@media (min-width:900px)': {
        width: '9.0vw'
      },
      '@media (min-width:1000px)': {
        width: '9.5vw'
      },
      '@media (min-width:1050px)': {
        width: '10.5vw'
      },
      '@media (min-width:1100px)': {
        width: '12.0vw'
      },
      '@media (min-width:1200px)': {
        width: '11.0vw'
      },
      '@media (min-width:1271px)': {
        width: '12.5vw'
      },
      '@media (min-width:1350px)': {
        width: '15.0vw'
      },
      '@media (min-width:1400px)': {
        width: '16.5vw'
      }
    },
    lastImported: {
      width: '40%',
      margin: '0 8px',
      display: 'flex',
      alignItems: 'center'
    },
    lastImportedLabel: {
      fontSize: '1rem',
      whiteSpace: 'nowrap'
    },
    lastImportedVal: {
      paddingLeft: '4px',
      fontSize: '1rem',
      fontWeight: 700,
      whiteSpace: 'nowrap'
    }
  })
);
export const FilterClinicStyles = makeStyles(() => ({
  edit: {
    marginTop: '0.3rem'
  },
  root: {
    width: '400px',
    '&:focus': {
      outline: 'none'
    }
  },
  tableContainer: {
    margin: '0rem 2rem 5rem',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    boxShadow: '0 0 0 1px rgb(63 63 68 / 5%), 0 1px 3px 0 rgb(63 63 68 / 15%)'
  },
  emptyTableStyle: {
    height: '3rem',
    overflow: 'auto',
    textAlign: 'center'
  },
  emptyTableWithSummary: {
    textAlign: 'center',
    overflow: 'hidden'
  },
  importClinicClass: {
    marginTop: '1rem',
    marginBottom: '1rem'
  },
  labelPosition: {
    whiteSpace: 'nowrap',
    margin: '5px 0 5px 0'
  },
  addDate: {
    width: '100%'
  },
  ClinicFilterHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem 16px'
  },
  ClinicMenu: {
    overflow: 'auto',
    '& li': {
      borderBottom: '1px solid #eeeeee'
    },
    '& li:last-child': {
      borderBottom: 'none'
    }
  },
  clinicMenuEmrProviderText: {},
  secondary: {
    '& .MuiListItemText-secondary': {
      fontSize: '0.9rem',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    wordBreak: 'break-all'
  },
  primary: {
    '& .MuiListItemText-primary': {
      fontSize: '1.2rem',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  gridText: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  clearAll: {
    textTransform: 'capitalize',
    fontSize: '1rem'
  },
  close: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '10px 16px',
    paddingTop: '16px'
  },
  statementTypeDropdown: {
    width: '300px'
  },
  paperHeading: {
    fontSize: '1.25rem',
    marginBottom: '12px',
    fontWeight: 'bold',
    paddingBottom: '1rem'
  },
  button: {
    fontFamily: APP.FONT_FAMILY.BOLD,
    height: '2.7rem',
    justifyContent: 'center',
    padding: 0,
    margin: '5px',
    '& .span': {
      padding: 0
    }
  },
  paper: {
    position: 'absolute',
    width: '30vw',
    minWidth: '400px',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '5px',
    boxShadow: '0 5px 10px 0 rgb(0 0 0 / 11%)',
    top: '50%',
    left: '50%',
    transform: `translate(-50%, -50%)`,
    padding: theme.spacing(3, 4)
  },
  actionButtons: {
    justifyContent: 'flex-end',
    display: 'flex'
  },
  actionTypeDropdown: {
    width: '350px'
  },
  renderAllInvoicesButtonsAddOn: {
    whiteSpace: 'nowrap'
  },
  lineHeight: {
    lineHeight: '1rem',
    height: '2.3rem'
  }
}));

export const importInvoicesStyles = {
  backgroundColor: 'transparent',
  width: '90%',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  textTransform: 'capitalize',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  wordBreak: 'break-word'
};
const statementArray = Object.values(StatementNoticeType);

// FIXME: ADD INTERFACE FOR THE PROPS
const DueInvoices = (props: any): ReactElement => {
  const classes = textFieldStyles();
  const dispatch = useDispatch();
  const popperClasses = remainderPopper();
  const ClinicClasses = FilterClinicStyles();
  const importSummaryStyle = cardStyle();
  const [smsCheck, setSmsCheck] = useState<boolean>(true);
  const [cardPopUpOpen, setCardPopUpOpen] = useState<boolean>(false);
  const [popUp, setPopUp] = useState<boolean>(false);
  const [clinics, setClinics] = useState<any[]>([]);
  const [request, setRequest] = useState<boolean>(false);
  const [emailCheck, setEmailCheck] = useState<boolean>(false);
  const [openDialogBox, setOpenDialogBox] = useState<boolean>(false);
  const [patientCount, setPatientCount] = useState<number>(0);
  const {
    groupId,
    selectedClinicId: acOfClinics = [],
    selectedClinicLabel: acOfClinicLabels = [],
    userPermissions = {},
    clinicNotificationBatches = {}
  } = props;
  const [pageNumber, setPageNum] = React.useState<number>(0);
  const [checkBoxes, setCheckBoxesValues]: any = useState({
    tableCheckBoxValues: [],
    buttonLoader: false,
    dateTimeDialog: false,
    loader: false,
    invoicesImportFlag: false
  });

  const [showMoreDetails, setShowMoreDetails] = useState({
    open: false,
    title: '',
    value: ''
  });

  const consolidatedBillingGroupEnable: boolean = useSelector(
    (state: any) => state.clinics.consolidatedBillingGroupEnable
  );
  const billingClinicId: number = useSelector(
    (state: any) => state.clinics.billingClinicId
  );

  const [openDateTimePicker, setDateTimePicker] = useState<boolean>(false);
  const {enqueueSnackbar} = useSnackbar();
  const {t} = useTranslation();
  const [remainderAnchorEl, setRemainderAnchorEl] = useState<any>(null);
  const [loader, setLoader] = useState<boolean>(true);
  // const [balanceDue, setBalanceDue]: any = useState('');
  const [labelName, setLabelName]: any = useState('');
  const [keyName, setKeyName]: any = useState('');

  const [summary, setSummary]: any = useState({});

  const [invoices, setInvoices]: any = useState([]);
  const [guarantorNotificationInfo, setGuarantorNotificationInfo] = useState({
    data: [] as any[],
    isLoading: false
  });

  const [remainderDates, setRemainderDates]: any = useState([]);
  const datesLength = remainderDates.length;

  const [phoneIds, setPhoneIds] = useState<string[]>([]);
  const [importFlag, setImportFlag]: any = useState(false);
  const [importStatementTypeFlag, setImportStatementTypeFlag]: any = useState(
    false
  );
  const [statementType, setStatementType] = React.useState<string>('');
  const [openNoticeType, setOpenNoticeType] = React.useState(false);
  const [anchorRef, setAnchorRef] = React.useState<HTMLButtonElement>();
  const [importErrorTableFLag, setImportErrorTableFLag] = useState<boolean>(
    false
  );
  const [importErrorInvoices, setImportErrorInvoices]: any = useState([]);
  const [guarantorValues, setGuarantorValues] = useState<{
    guarantorDrawerOpen: boolean;
    guarantorId: number | any;
    guarantorName: number | any;
  }>({
    guarantorDrawerOpen: false,
    guarantorId: '',
    guarantorName: ''
  });
  const [failedInvoicesClinic, setFailedInvoicesClinic]: any = useState('');
  const [sendToAllInvoices, setAllInvoices] = useState<boolean>(false);
  const [confirmDialogOpen, setConfirmDialogToAllInvoices] = useState<boolean>(
    false
  );
  const [lastImportedDate, setLastImportedDate] = useState('');
  const [clinicEmrProvider, setClinicEmrProvider] = useState('');
  const [
    confirmDialogOpenForNoticeType,
    setConfirmDialogOpenForNoticeType
  ] = useState<boolean>(false);
  const [
    selectedGuarantorForUpdateNoticeType,
    setSelectedGuarantorForUpdateNoticeType
  ] = useState<any>({});
  const [selectedNotificationCount, setSelectedNotificationCount] = useState<
    any[]
  >([]);
  const [selectedStatementDueStatus, setStatementDueStatus] = useState<any[]>(
    []
  );

  const [optOutStatement, setOptOutStatement] = useState<any[]>([]);

  const [lastImportedIds, setLastImportedIds] = useState<any[]>([]);
  const [selectedLastImportedIds, setSelectedLastImportedIds] = useState<any[]>(
    []
  );
  const [showFnPdCheck, setFnPdCheckView] = useState<boolean>(false);
  const [showConversation, setShowConversation] = useState<boolean>(false);
  const [showConversationDataObj, setShowConversationDataObj] = useState<any>(
    {}
  );

  const [showEmptyTable, setShowEmptyTable] = useState<boolean>(false);

  const [customMessageRequest, setCustomMessageRequest] = useState<boolean>(
    false
  );

  const [customMessageType, setCustomMessageType] = useState<string>('');

  const [
    openCustomMessageDialog,
    setOpenCustomMessageDialog
  ] = useState<boolean>(false);

  const dateTime: any = useSelector(
    (state: any) => state.payments.scheduleSendDate || []
  );

  const [minimumAmount, setMinimumAmount] = useState('');
  const [notificationDuration, setNotificationDuration] = useState('');
  const [maximumAmount, setMaximumAmount] = useState('');
  const [voucherFlag, setVoucherFlag]: any = useState(false);
  const patientShared = useSelector(
    (state: any) => state.clinics.patientShared
  );
  const userGroups = useSelector((state: any) => state.auth.userGroups);
  const [currentGroup, setCurrentGroup]: any = useState<any>({});
  // search text ref
  const searchInputRef = React.useRef();
  // grid table ref
  const tableRef: any = React.useRef();

  const popOverItems: Array<CustomPopOverListItemType> = Object.values(
    StatementNoticeType
  ).map(n => {
    if (n.key == StatementNoticeType.STD.key) {
      return {
        id: n.key,
        name: t(`DUE_INVOICES.UPDATE_NOTICE_TYPE.${n.key}`)
      };
    }
    if (keyName !== n.key || labelName !== n.label) {
      return {
        id: n.key,
        name: t(`DUE_INVOICES.UPDATE_NOTICE_TYPE.${n.key}`)
      };
    } else {
      return {
        id: '',
        name: ''
      };
    }
  });

  // Notification update
  const [phonePopOver, setPhonePopOver] = useState<boolean>(false);
  const [selectedGuarantor, setSelectedGuarantor] = useState<any>({});

  const [paymentPlanStatus, setPaymentPlanStatus] = useState<any>({});

  const [
    sendStatementsPaymentPlan,
    setSendStatementsPaymentPlan
  ] = useState<boolean>(false);

  const openPhonePopOver = async (data: any): Promise<void> => {
    setPhonePopOver(true);
    setSelectedGuarantor(data);
  };

  // *** Messages Dialog component start *** //

  // function for opening messages conversation from material-UI dialog
  const onSendMessageClick = async (data: any): Promise<void> => {
    try {
      const lastMessageObj = await getLastMessage(
        groupId,
        acOfClinics[0],
        data.id
      );
      setShowConversationDataObj({
        messageId: lastMessageObj.data?.id,
        clinicId: acOfClinics[0],
        guarantorId: data.id
      });
      setShowConversation(true);
    } catch (err: any) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      throw err;
    }
  };
  const handleConversationClose = () => {
    setShowConversation(false);
    setShowConversationDataObj({});
  };

  const renderConversationsDialog = () => {
    return (
      <MessagesConversationDialog
        groupId={groupId}
        clinicId={showConversationDataObj?.clinicId}
        messageId={showConversationDataObj?.messageId}
        guarantorId={showConversationDataObj?.guarantorId}
        handleClose={handleConversationClose}
        showConversation={showConversation}
      />
    );
  };

  // *** Messages Dialog End *** //

  const openPayPopOver = (data: any) => {
    setCardPopUpOpen(true);
    setSelectedGuarantor(data);
    // UPDATING STATEMENT BALANCE AND PAYMENT TYPE TO REDUX,
    props._updatePaymentType(PaymentTypes.STATEMENT_PAYMENT);
    props._guarantorPayAmount(data.balance_amount);
    props._guarantorPayCashAmount(data.balance_amount);
  };

  const closePayPopOver = () => {
    setCardPopUpOpen(false);
    setSelectedGuarantor(null);
    props._guarantorPayAmount(0);
    props._guarantorPayCashAmount(0);
  };

  // Send EMAIL
  const [emailPopOver, setEmailPopOver] = useState<boolean>(false);

  const openEmailPopOver = async (data: any): Promise<void> => {
    setEmailPopOver(true);
    setSelectedGuarantor(data);
  };

  const closeEmailPopOver = () => {
    setEmailPopOver(false);
    setSelectedGuarantor(null);
  };

  const handleTableCheckBoxes = (rows: any): any => {
    const values = rows.map((row: any) => row.id);
    setCheckBoxesValues({
      ...checkBoxes,
      tableCheckBoxValues: values
    });
  };

  const combineFilters = (): string => {
    let combinedString = '';
    if (statementType.length) {
      combinedString += t(
        statementArray.filter(type => type.key === statementType)[0].label
      );
    }
    if (selectedNotificationCount.length) {
      if (statementType.length && selectedStatementDueStatus.length) {
        combinedString += ', ';
      } else if (statementType.length && !selectedStatementDueStatus.length) {
        combinedString += ' And ';
      }
      combinedString += t(selectedNotificationCount[0].label);
    }
    if (selectedStatementDueStatus.length) {
      if (statementType.length && selectedNotificationCount.length) {
        combinedString += ' And ';
      } else if (statementType.length && !selectedNotificationCount.length) {
        combinedString += 'And ';
      }
      combinedString += t(selectedStatementDueStatus[0].label);
    }
    return combinedString;
  };

  const getGroupDetails = async (id: any) => {
    const response: any = await getClinicGroupsDetails(id);
    if (response?.data) {
      setCurrentGroup(response.data);
    }
  };

  const getGroupClinics = async (
    id: any,
    fetchLastImportedMonth = false
  ): Promise<void> => {
    try {
      const previousSelectedClinic: any[] = [...acOfClinics];
      props._statementsSelectedClinic([], [], '', '');
      getAllClinics(id)
        .then(
          async (res: any): Promise<any> => {
            if (res && res?.data && Array.isArray(res?.data?.rows)) {
              dispatch(_setClinics(res.data.rows));
              const clinicRows = res.data.rows;

              setClinics(clinicRows);

              let selectedClinicDetails: any = {};
              if (clinicRows.length === 1) {
                selectedClinicDetails = clinicRows[0];
              } else {
                // CHECKING CONSOLIDATED BILLING IS TRUE, FILTER  WITH BILLING  CLINIC ID ONLY IF Clinic is not preselected
                if (
                  consolidatedBillingGroupEnable &&
                  billingClinicId &&
                  previousSelectedClinic?.length === 0
                ) {
                  selectedClinicDetails = clinicRows.find(
                    (clinic: any) => clinic.id === billingClinicId
                  );
                } else if (previousSelectedClinic?.length > 0) {
                  selectedClinicDetails = clinicRows.find((clinic: any) =>
                    previousSelectedClinic.includes(clinic.id)
                  );
                }
              }

              if (
                selectedClinicDetails &&
                Object.keys(selectedClinicDetails).length === 0
              ) {
                props._statementsSelectedClinic([], [], '', '');
                setClinicEmrProvider('');
              } else if (
                selectedClinicDetails &&
                Object.keys(selectedClinicDetails).length > 0
              ) {
                props._statementsSelectedClinic(
                  [selectedClinicDetails?.id],
                  [selectedClinicDetails?.name],
                  selectedClinicDetails?.zone,
                  selectedClinicDetails?.emr_provider
                );
                setClinicEmrProvider(selectedClinicDetails?.emr_provider);
              }
            } else {
              setClinics([]);
              props._statementsSelectedClinic([], [], '');
            }
          }
        )
        .catch(error => {
          enqueueSnackbar(
            t('CLINICS.CLINIC_GROUP_CLINICS_ERROR'),
            SnackBarConfig('e')
          );
          throw error;
        });
    } catch (error: any) {
      enqueueSnackbar(
        (error && error.message) || t('CLINICS.CLINIC_GROUP_CLINICS_ERROR'),
        SnackBarConfig('e')
      );
      throw error;
    }
  };

  // KEPT COMMENTED CODE FOR FUTURE REFERENCE
  // const openDrawer = (
  //   // eslint-disable-next-line no-shadow
  //   groupId: number,
  //   selectedClinicId: number,
  //   patientId: number
  // ): void => {
  //   // try {
  //   // setPatientName(name);
  //   // setBalanceDue(due);
  //   dispatch(_patientDrawerDetails(groupId, selectedClinicId, patientId));

  //   //   const invoiceResponse = await invoiceDetails(groupId, invoiceNumber);
  //   //   if (invoiceResponse && invoiceResponse?.data?.invoice_lines?.length) {
  //   //     setInvoiceLineData(invoiceResponse?.data);
  //   //   } else {
  //   //     setInvoiceLineData({
  //   //       invoiceLines: [],
  //   //       total_copay_amount: 0
  //   //     });
  //   //   }
  //   //   setOpen(true);
  //   // } catch (error) {
  //   //   enqueueSnackbar(
  //   //     (error && error.message) ||
  //   //       t('ERROR WHILE FETCHING INVOICE SERVICE DATA'),
  //   //     SnackBarConfig('e')
  //   //   );
  //   //   throw error;
  //   // }
  // };

  const resetPagesInGrid = (fallInPageNumber?: number): void => {
    setRequest(false);
    setCustomMessageRequest(false);
    setCheckBoxesValues({
      ...checkBoxes,
      tableCheckBoxValues: []
    });
    if (
      tableRef.current?.onQueryChange &&
      typeof tableRef.current.onQueryChange === 'function'
    ) {
      tableRef.current.onQueryChange({page: fallInPageNumber || 0});
    }
  };

  const openGuarantorDrawer = async (
    name: any,
    guarantorId: string | number
  ): Promise<any> => {
    setGuarantorValues({
      ...guarantorValues,
      guarantorDrawerOpen: true,
      guarantorId: guarantorId,
      guarantorName: name
    });
  };

  const closeGuarantorDrawer = (): void => {
    setGuarantorValues({
      ...guarantorValues,
      guarantorDrawerOpen: false,
      guarantorId: '',
      guarantorName: ''
    });
    resetPagesInGrid(pageNumber);
  };

  const fetchInvoicePatientsCount = async (data: {
    id: number;
    clinicId: number | string;
    options: any;
    resetFilters?: boolean;
    cancelToken?: CancelTokenSource;
  }) => {
    try {
      const {id, clinicId, resetFilters, options, cancelToken} = data;
      const response = await fetchDueInvoicesPatientCount(
        id,
        clinicId,
        resetFilters ? {} : options,
        false,
        false,
        cancelToken
      );
      setPatientCount(response?.data?.patients_count ?? 0);
    } catch (error: any) {
      if (error?.message) {
        enqueueSnackbar(error.message, SnackBarConfig('e'));
      }
    }
  };

  const getGuarantorsInvoiceNotificationDetailsReq = React.useRef<CancelTokenSource | null>(
    null
  );
  const getGuarantorsInvoiceNotificationDetails = async ({
    clinicGroupId,
    clinicId,
    guarantorIds = []
  }: {
    clinicGroupId: number;
    clinicId: number;
    guarantorIds: number[];
  }) => {
    if (getGuarantorsInvoiceNotificationDetailsReq.current) {
      // Cancelling previous API calls
      getGuarantorsInvoiceNotificationDetailsReq.current.cancel();
    }
    getGuarantorsInvoiceNotificationDetailsReq.current = axios.CancelToken.source();
    const currentReqToken =
      getGuarantorsInvoiceNotificationDetailsReq.current.token;
    try {
      setGuarantorNotificationInfo(prev => ({...prev, isLoading: true}));
      const res = await fetchGuarantorsInvoiceNotificationDetails({
        clinic_group_id: clinicGroupId,
        clinic_id: clinicId,
        payload: {
          guarantor_ids: guarantorIds
        },
        cancelToken: getGuarantorsInvoiceNotificationDetailsReq.current
      });
      if (Array.isArray(res?.data?.rows)) {
        setGuarantorNotificationInfo(prev => ({...prev, data: res.data.rows}));
      } else {
        setGuarantorNotificationInfo(prev => ({...prev, data: []}));
      }
    } catch (error: any) {
      if (error?.message) {
        enqueueSnackbar(error?.message, SnackBarConfig('e'));
      }
      setGuarantorNotificationInfo(prev => ({...prev, data: []}));
    } finally {
      if (
        currentReqToken ===
        getGuarantorsInvoiceNotificationDetailsReq.current.token
      ) {
        setGuarantorNotificationInfo(prev => ({...prev, isLoading: false}));
      }
    }
  };

  const getGuarantorNotificationInfo = (guarantorId: number) => {
    return guarantorNotificationInfo.data.find(
      info => info.guarantor_id === guarantorId
    );
  };

  const fetchAllInvoiceNotificationDetailsReq = React.useRef<CancelTokenSource | null>(
    null
  );
  const allDueInvoices = async (data: {
    id: number;
    clinicId: any;
    searchText?: string;
    resetFilters?: boolean;
    limit?: number;
    offset?: number;
    sort?: {sort: string; order: string};
    downloadRequest?: boolean;
  }): Promise<any> => {
    if (!data.clinicId) {
      enqueueSnackbar(t('DUE_INVOICES.SELECT_PRACTICE'), SnackBarConfig('e'));
      return;
    }
    try {
      const {
        id,
        clinicId,
        searchText,
        resetFilters,
        limit,
        offset,
        sort,
        downloadRequest
      } = data;
      const options: any = {};
      if (searchText || (searchInputRef.current as any).value) {
        const nameSearchText =
          searchText || (searchInputRef.current as any).value;
        // Minimum length of search string should be 3 characters
        if (typeof nameSearchText === 'string' && nameSearchText.length > 2) {
          options.search_text = nameSearchText;
        }
      }
      if (acOfClinics.length) {
        options.clinics = acOfClinics;
      }

      if (phoneIds.length) {
        options.carrier_type = phoneIds[0];
      }
      if (selectedNotificationCount.length) {
        options.notification_count = selectedNotificationCount[0].value;
      }
      if (selectedStatementDueStatus.length) {
        options.payment_flow_status = selectedStatementDueStatus[0].value;
      }

      if (minimumAmount && minimumAmount.length) {
        options.min_amount = minimumAmount;
      }
      if (notificationDuration && notificationDuration.length) {
        options.pending_notification_to_guarantor_interval = parseInt(
          notificationDuration
        );
      }

      if (maximumAmount && maximumAmount.length) {
        options.max_amount = maximumAmount;
      }
      if (optOutStatement.length) {
        options.opt_out_electronic_statement = optOutStatement[0].value;
      }
      options.due_notice = statementType;

      if (paymentPlanStatus?.value) {
        options.payment_plan_status = paymentPlanStatus?.value;
      }

      if (downloadRequest) {
        downloadDueInvoices(id, clinicId, resetFilters ? {} : options, sort)
          .then((res: any) => {
            const url = window.URL.createObjectURL(new Blob([res]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
              'download',
              `due_invoices${
                acOfClinicLabels.length ? `_${acOfClinicLabels[0]}` : ''
              }.csv`
            );
            document.body.appendChild(link);
            link.click();
          })
          .catch((error: any) => {
            enqueueSnackbar(t(error.message), SnackBarConfig('e'));
            throw error;
          });
        return;
      } else {
        // Fetch patients count in separate api
        if (fetchAllInvoiceNotificationDetailsReq.current) {
          fetchAllInvoiceNotificationDetailsReq.current.cancel();
        }
        fetchAllInvoiceNotificationDetailsReq.current = axios.CancelToken.source();
        fetchInvoicePatientsCount({
          id,
          clinicId,
          options,
          resetFilters,
          cancelToken: fetchAllInvoiceNotificationDetailsReq.current
        });
        const allDueInvoicesResponse = await fetchDueInvoices(
          id,
          clinicId,
          resetFilters ? {} : options,
          limit,
          offset,
          sort,
          false,
          false,
          fetchAllInvoiceNotificationDetailsReq.current
        );
        if (allDueInvoicesResponse?.data?.rows?.length > 0) {
          setInvoices(allDueInvoicesResponse?.data?.rows);
          getGuarantorsInvoiceNotificationDetails({
            clinicGroupId: id,
            clinicId: clinicId,
            guarantorIds: allDueInvoicesResponse.data.rows.map((i: any) => i.id)
          });
        } else {
          setInvoices([]);
          setGuarantorNotificationInfo(prev => ({
            ...prev,
            data: [],
            isLoading: false
          }));
        }

        // trigger the request to get details for the guarantor

        // commented for time being will umount once backend is updated
        // // dispatching the rowData into redux to start the timer if the rowRecords are one..... //
        // const rowCount: any = allDueInvoicesResponse?.data?.count;
        // const count: any = parseInt(rowCount || 0);
        // if (count === 1) {
        //   const ccmPatientId: any = allDueInvoicesResponse?.data?.rows?.[0];
        //   // de- structing the APi response and dispatching the action

        //   // FIXME:Need to the update the API response by includingResponse
        //   // below paramters for the due invoices API
        //   //   ccm_patient_id
        //   //   first_name
        //   //   middle_name
        //   //   last_name
        //   //   account_number

        //   const {
        //     ccm_patient_id,
        //     first_name,
        //     middle_name,
        //     last_name,
        //     account_number
        //   } = ccmPatientId;

        //   if (ccmPatientId) {
        //     dispatch(
        //       _ccmSinglePatientDetails(
        //         ccm_patient_id,
        //         HelperUtils.commaSeparatedFullName(
        //           first_name,
        //           last_name,
        //           middle_name
        //         ),
        //         account_number,
        //         true,
        //         // TODO: Need to pass patient id, how do I get and pass it??
        //         1
        //       )
        //     );
        //   }
        // }
        // FIXME: else condition need to handle After API is updated with CCM patient id

        // returning the API response heree

        return allDueInvoicesResponse;
      }
    } catch (error: any) {
      if (error?.message) {
        enqueueSnackbar(error.message, SnackBarConfig('e'));
      }
      throw error;
    }
  };

  const renderImportSummary = (importSummary: {
    total_records?: number;
    saved_records?: number;
    duplicate_records?: number;
    guarantor_due_records?: number;
    failed_records?: number;
  }) => {
    return (
      <div className={importSummaryStyle.container}>
        <div className={importSummaryStyle.wrapper}>
          <span className={importSummaryStyle.cards}>
            {t('DUE_INVOICES.IMPORT_SUMMARY.TOTAL_RECORDS')}
          </span>
          <span className={importSummaryStyle.cardsVal}>
            {importSummary?.total_records ?? 0}
          </span>
        </div>
        <div className={importSummaryStyle.wrapper}>
          <span className={importSummaryStyle.cards}>
            {t('DUE_INVOICES.IMPORT_SUMMARY.SAVED_RECORDS')}
          </span>
          <span className={importSummaryStyle.cardsVal}>
            {importSummary?.saved_records ?? 0}
          </span>
        </div>
        <div className={importSummaryStyle.wrapper}>
          <span className={importSummaryStyle.cards}>
            {t('DUE_INVOICES.IMPORT_SUMMARY.DUPLICATE_RECORDS')}
          </span>
          <span className={importSummaryStyle.cardsVal}>
            {importSummary?.duplicate_records ?? 0}
          </span>
        </div>
        <div className={importSummaryStyle.wrapper}>
          <span className={importSummaryStyle.cards}>
            {t('DUE_INVOICES.IMPORT_SUMMARY.NEW_GUARANTOR_DUE_RECORDS')}
          </span>
          <span className={importSummaryStyle.cardsVal}>
            {importSummary?.guarantor_due_records ?? 0}
          </span>
        </div>
        <div className={importSummaryStyle.wrapperLast}>
          <span className={importSummaryStyle.cards}>
            {t('DUE_INVOICES.IMPORT_SUMMARY.FAILED_RECORDS')}
          </span>
          <span className={importSummaryStyle.cardsVal}>
            {importSummary?.failed_records ?? 0}
          </span>
        </div>
      </div>
    );
  };

  const getLastImportIds = async (clinicId?: any) => {
    try {
      const response: any = await getImportSummaryImportIds(
        groupId,
        ImportSummaryTypes.INVOICE,
        clinicId
      );
      if (response?.data) {
        setLastImportedIds(response.data);
      }
    } catch (err: any) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      throw err;
    }
  };

  const getFailedToSaveInvoices = async (importId: string) => {
    try {
      const response: any = await getImportErrorData(
        groupId,
        ImportSummaryTypes.INVOICE,
        importId,
        acOfClinics[0]
      );
      if (
        response?.data?.errors?.patientsNotFoundError?.length ||
        response?.data?.errors?.systemErrors?.length
      ) {
        // setImportError(true);
        setFailedInvoicesClinic(response?.data?.clinic_name);
        setImportErrorInvoices([
          ...(response?.data.errors?.patientsNotFoundError ?? []),
          ...(response?.data.errors?.systemErrors ?? [])
        ]);
      } else {
        // setImportError(false);
        setImportErrorInvoices([]);
      }

      setLastImportedDate(response.data.date);
      if (response?.data?.report_data) {
        setSummary(response?.data?.report_data);
      } else {
        setSummary({});
      }
    } catch (error: any) {
      enqueueSnackbar(error && error.message, SnackBarConfig('e'));
      throw error;
    }
  };

  const getGroupAndClinicDetails = async (): Promise<void> => {
    await getGroupDetails(groupId);
    await getGroupClinics(groupId, true);
    setLoader(false);
  };
  useEffect(() => {
    if (!importErrorTableFLag) {
      getGroupAndClinicDetails();
    } else if (importErrorTableFLag && acOfClinics.length) {
      getLastImportIds(acOfClinics[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [importErrorTableFLag]);

  const handleSearchText = useDebouncedCallback(
    // function
    () => {
      // Minimum length of search string should be 3 characters
      const searchText = (searchInputRef.current as any).value;
      if (
        !searchText ||
        (typeof searchText === 'string' && searchText?.length > 2)
      ) {
        resetPagesInGrid();
      }
    },
    // delay in ms
    SEARCH_DEBOUNCE_DELAY
  );

  const clearSummaryDataOnChange = () => {
    setImportErrorInvoices([]);
    setSelectedLastImportedIds([]);
    setLastImportedDate('');
    setFailedInvoicesClinic('');
    setLastImportedDate('');
    setSummary({});
  };

  const clinicsMethod = async (option: any): Promise<void> => {
    setClinicEmrProvider(option.emr_provider);
    props._statementsSelectedClinic(
      [option.id],
      [option.name],
      option?.zone,
      option?.emr_provider
    );
    if (importErrorTableFLag) {
      clearSummaryDataOnChange();
      getLastImportIds(option.id);
    }
  };

  const handleAccessOfClinics = (
    event: React.ChangeEvent<{value: unknown}>
  ) => {
    // const acClinics: any = [];
    // setAccessClinicLabels(acClinics as string[]);
  };

  const handleCancelRequest = (): void => {
    setRequest(false);
    setCustomMessageRequest(false);
    setCheckBoxesValues({
      ...checkBoxes,
      tableCheckBoxValues: []
    });
    if (typeof tableRef.current?.onAllSelected === 'function') {
      tableRef.current.onAllSelected(false);
    }
  };

  const clearSelectedLastImportedIds = () => {
    clearSummaryDataOnChange();
  };

  const clearClinicFilter = () => {
    setPhoneIds([]);
    setSelectedNotificationCount([]);
    setStatementDueStatus([]);
    if ((searchInputRef.current as any)?.value) {
      (searchInputRef.current as any).value = '';
    }
    // setStatementTypeLabel(t('DUE_INVOICES.PLACEHOLDERS.STATEMENT_TYPE'));
    setStatementType('');
    setOptOutStatement([]);
    setMinimumAmount('');
    setNotificationDuration('');
    setMaximumAmount('');
    props._statementsSelectedClinic([], [], '', '');
    if (importErrorTableFLag) {
      clearSummaryDataOnChange();
      setLastImportedIds([]);
    }
  };

  const getReminderType = (): string[] => {
    const reminderType: string[] = [];
    if (smsCheck) {
      reminderType.push('sms');
    }
    if (emailCheck) {
      reminderType.push('email');
    }
    return reminderType;
  };

  const notificationType = () => {
    let reminderType = '';
    if (smsCheck) {
      reminderType += t('COMMON.TEXT');
    }
    if (emailCheck) {
      reminderType += t('COMMON.EMAIL');
    }
    if (smsCheck && emailCheck) {
      reminderType = '';
      reminderType += t('COMMON.TEXT_AND_EMAIL');
    }
    return reminderType;
  };

  const handleSendRequest = async (
    salutation?: boolean,
    message?: string,
    sendNotification?: boolean
  ): Promise<void> => {
    try {
      if (
        (smsCheck || emailCheck) &&
        (checkBoxes.tableCheckBoxValues.length > 0 || sendToAllInvoices) &&
        acOfClinics.length
      ) {
        setCheckBoxesValues({
          ...checkBoxes,
          buttonLoader: true
        });
        const remindersObject: any = {
          guarantors: sendToAllInvoices ? [] : checkBoxes.tableCheckBoxValues,
          reminder_type: getReminderType(),
          due_type: statementType,
          select_all: sendToAllInvoices
        };

        if (salutation) {
          remindersObject.includeSalutation = salutation;
        }

        if (message) {
          remindersObject.message = message;
        }
        // salutation?: boolean,
        // message?: string
        if (selectedNotificationCount.length) {
          remindersObject['notification_count'] =
            selectedNotificationCount[0].value;
        }
        if (selectedStatementDueStatus.length) {
          remindersObject['payment_flow_status'] =
            selectedStatementDueStatus[0].value;
        }

        remindersObject.send_notifications_to_payment_plan_guarantor = sendStatementsPaymentPlan;
        remindersObject.send_notification_to_guarantors = sendNotification;

        let response: any;
        if (
          customMessageType ===
          CUSTOM_NOTIFICATION_TYPES.CUSTOM_MESSAGE_SCHEDULE_SEND
        ) {
          remindersObject.reminder_date = dateTime;

          response = await scheduleReminders(
            groupId,
            acOfClinics[0],
            remindersObject
          );
        } else {
          response = await sendReminders(
            groupId,
            acOfClinics[0],
            remindersObject
          );
        }

        if (response) {
          setCustomMessageType('');
          handleCancelRequest();
          resetPagesInGrid();
          enqueueSnackbar(
            message
              ? t('DUE_INVOICES.CUSTOM_MESSAGE_SENT')
              : t('DUE_INVOICES.MESSAGE_SENT'),
            SnackBarConfig('i')
          );
          if (acOfClinics[0] === clinicNotificationBatches.clinicId) {
            props._clinicNotificationBatchIds({});
          }
        }
      } else {
        if (!acOfClinics.length) {
          enqueueSnackbar(
            t('DUE_INVOICES.SELECT_A_CLINIC'),
            SnackBarConfig('e')
          );
        } else if (!smsCheck && !emailCheck) {
          enqueueSnackbar(t('DUE_INVOICES.MESSAGE_TYPE'), SnackBarConfig('e'));
        } else {
          enqueueSnackbar(
            t('DUE_INVOICES.SELECT_INVOICES'),
            SnackBarConfig('e')
          );
        }
      }
    } catch (error: any) {
      enqueueSnackbar(
        (error && error.message) || t('DUE_INVOICES.REQUEST_SENT_ERROR'),
        SnackBarConfig('e')
      );
    } finally {
      setCheckBoxesValues({
        ...checkBoxes,
        buttonLoader: false,
        tableCheckBoxValues: []
      });
      setOpenCustomMessageDialog(false);
    }
  };

  const renderSearchFiled = (): ReactElement => {
    return (
      <div>
        <SearchField
          className="searchView"
          inputRef={searchInputRef}
          placeholder={t('DUE_INVOICES.PLACEHOLDERS.SEARCH')}
          style={{height: '2.3rem'}}
          onChange={(): void => handleSearchText()}
          disabled={!acOfClinics.length}
        />
      </div>
    );
  };

  const renderClinicFilters = (): ReactElement => {
    return (
      <div style={{minWidth: '230px'}}>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          data-test-id="pcl-statements-selectDueInvoicePractice"
          value={
            acOfClinics.length
              ? acOfClinicLabels
              : [t('DUE_INVOICES.PLACEHOLDERS.SELECT_CLINIC')]
          }
          variant="outlined"
          onChange={handleAccessOfClinics}
          fullWidth={true}
          style={acOfClinics.length ? {} : {opacity: 0.5}}
          input={<CustomSelectField />}
          IconComponent={KeyboardArrowDownIcon}
          className="selectView select-clinic">
          <div className={ClinicClasses.root}>
            <div className={ClinicClasses.ClinicFilterHeader}>
              <Typography style={{fontSize: '1.3rem'}}>
                {t('PATIENTS.CLINICS')}
              </Typography>
              <Button
                className={ClinicClasses.clearAll}
                onClick={clearClinicFilter}>
                {t('COMMON.CLEAR_ALL')}
              </Button>
            </div>
            <Divider />
            <div className={ClinicClasses.ClinicMenu}>
              {clinics.map((clinic: any) => (
                <MenuItem
                  key={clinic.id}
                  value={clinic.name}
                  onClick={async (): Promise<void> => {
                    setLoader(true);
                    await clinicsMethod(clinic);
                    setLoader(false);
                  }}>
                  <ListItemText
                    className={[
                      ClinicClasses.secondary,
                      ClinicClasses.primary
                    ].join(' ')}
                    primary={clinic.name}
                    secondary={`${clinic.city}, ${clinic.country}`}
                  />
                  <Radio checked={acOfClinics.indexOf(clinic.id) > -1} />
                </MenuItem>
              ))}
            </div>
          </div>
        </Select>
        {/* </div> */}
      </div>
    );
  };

  const handleUpdateNoticeDueType = async (
    guarantorId: number | string,
    dueNoticeType: string
  ) => {
    try {
      const response: any = await updateGuarantorDueNoticeType(
        groupId,
        acOfClinics[0],
        guarantorId,
        {
          due_notice_type: dueNoticeType
        }
      );
      setSelectedGuarantorForUpdateNoticeType({});
      enqueueSnackbar(response && response.message, SnackBarConfig('s'));
      resetPagesInGrid(pageNumber);
    } catch (err: any) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      throw err;
    } finally {
      // TODO
    }
  };

  const renderConfirmationForUpdateStatementType = () => {
    if (
      confirmDialogOpenForNoticeType &&
      selectedGuarantorForUpdateNoticeType.dueNoticeType ===
        StatementNoticeType.STD.key
    ) {
      return (
        <MakeSettleStatement
          title={
            <Trans
              i18nKey={
                selectedGuarantorForUpdateNoticeType.dueNoticeType ===
                StatementNoticeType.STD.key
                  ? 'DUE_INVOICES.SETTLE_STATEMENT_TITLE'
                  : 'DUE_INVOICES.UPDATE_DUE_NOTICE_TYPE_TITLE'
              }
              values={{
                name: selectedGuarantorForUpdateNoticeType.name
              }}
              components={[<strong key={'X'} />]}
            />
          }
          subTitle={
            <Trans
              i18nKey={
                selectedGuarantorForUpdateNoticeType.dueNoticeType ===
                StatementNoticeType.STD.key
                  ? 'DUE_INVOICES.SETTLE_DUE_NOTICE_TYPE_NOTE'
                  : 'DUE_INVOICES.UPDATE_DUE_NOTICE_TYPE_NOTE'
              }
              values={{
                notice_type:
                  selectedGuarantorForUpdateNoticeType.dueNoticeTypeLabel,
                name: selectedGuarantorForUpdateNoticeType.name
              }}
              components={[<strong key={'X'} />]}
            />
          }
          open={confirmDialogOpenForNoticeType}
          onClose={res => {
            setConfirmDialogOpenForNoticeType(false);
            setSelectedGuarantorForUpdateNoticeType({});
            if (res === 'submit') {
              resetPagesInGrid(pageNumber);
            }
          }}
          clinicId={acOfClinics[0]}
          groupId={groupId}
          guarantorId={selectedGuarantorForUpdateNoticeType.id}
        />
      );
    }
    return (
      <ConfirmationDialog
        open={confirmDialogOpenForNoticeType}
        onClose={response => {
          if (response === 'confirm') {
            if (!acOfClinics.length) {
              enqueueSnackbar(
                t('DUE_INVOICES.SELECT_A_CLINIC'),
                SnackBarConfig('e')
              );
            } else {
              handleUpdateNoticeDueType(
                selectedGuarantorForUpdateNoticeType.id,
                selectedGuarantorForUpdateNoticeType.dueNoticeType
              );
            }
          }
          setConfirmDialogOpenForNoticeType(false);
          setSelectedGuarantorForUpdateNoticeType({});
        }}
        title={
          <Trans
            i18nKey={
              selectedGuarantorForUpdateNoticeType.dueNoticeType ===
              StatementNoticeType.STD.key
                ? 'DUE_INVOICES.SETTLE_STATEMENT_TITLE'
                : 'DUE_INVOICES.UPDATE_DUE_NOTICE_TYPE_TITLE'
            }
            values={{
              name: selectedGuarantorForUpdateNoticeType.name
            }}
            components={[<strong key={'X'} />]}
          />
        }
        description={
          <Trans
            i18nKey={
              selectedGuarantorForUpdateNoticeType.dueNoticeType ===
              StatementNoticeType.STD.key
                ? 'DUE_INVOICES.SETLLE_DUE_NOTICE_TYPE_NOTE'
                : 'DUE_INVOICES.UPDATE_DUE_NOTICE_TYPE_NOTE'
            }
            values={{
              notice_type:
                selectedGuarantorForUpdateNoticeType.dueNoticeTypeLabel,
              name: selectedGuarantorForUpdateNoticeType.name
            }}
            components={[<strong key={'X'} />]}
          />
        }
      />
    );
  };

  const handleCloseStatementType = () => {
    setOpenNoticeType(false);
  };

  const handleToggleStatementType = (event: any, guarantorData: any) => {
    if (guarantorData.due_notice_type === StatementNoticeType.RD.key) {
      setLabelName(StatementNoticeType.RD.label);
      setKeyName(StatementNoticeType.RD.key);
    } else if (guarantorData.due_notice_type === StatementNoticeType.FN.key) {
      setLabelName(StatementNoticeType.FN.label);
      setKeyName(StatementNoticeType.FN.key);
    } else {
      setLabelName(StatementNoticeType.PD.label);
      setKeyName(StatementNoticeType.PD.key);
    }
    setOpenNoticeType(true);
    setAnchorRef(event.currentTarget);
    setSelectedGuarantorForUpdateNoticeType({
      id: guarantorData.id,
      name: HelperUtils.commaSeparatedFullName(
        guarantorData.first_name,
        guarantorData.last_name,
        guarantorData.middle_name
      )
    });
  };

  const handlePopOverItemClick = (item: CustomPopOverListItemType) => {
    let sT: any = statementArray.find(s => s.key === item.id);
    if (sT) {
      sT = sT.label;
    }

    setSelectedGuarantorForUpdateNoticeType({
      ...selectedGuarantorForUpdateNoticeType,
      dueNoticeType: item.id,
      dueNoticeTypeLabel: sT
    });
    setConfirmDialogOpenForNoticeType(true);
  };

  const renderPopover = (): React.ReactElement => {
    return (
      <CustomPopOver
        open={openNoticeType}
        anchorEl={anchorRef || null}
        listItems={popOverItems}
        position="bottom-end"
        handleClose={handleCloseStatementType}
        handleListItemClick={item => {
          handlePopOverItemClick(item);
        }}
      />
    );
  };

  const renderImportDialog = () => {
    return (
      <ImportFileDialog
        open={importFlag}
        title={t('DUE_INVOICES.IMPORT_EXPORT_DATA')}
        subtitle={t('DUE_INVOICES.IMPORT_EXPORT_DATA_SUBTITLE')}
        onClose={res => {
          if (res === 'confirm') {
            getGroupClinics(groupId, true).then(() => {
              resetPagesInGrid();
            });
          }
          setImportFlag(false);
        }}
        clinics={clinics}
        groupId={groupId}
        importType={IMPORT_TYPES.STATEMENTS}
        selectFileTitle={t('DUE_INVOICES.HEADERS.IMPORT_STATEMENT_FILE')}
        handleFlag={(item: boolean) => {
          setShowEmptyTable(item);
        }}
      />
    );
  };

  const renderImportStatementTypeDialog = () => {
    return (
      <ImportFileDialog
        open={importStatementTypeFlag}
        title={t('DUE_INVOICES.IMPORT_EXPORT_STATEMENT_TYPE_DATA')}
        subtitle={t('DUE_INVOICES.IMPORT_EXPORT_DATA_STATEMENT_TYPE_SUBTITLE')}
        onClose={() => {
          setImportStatementTypeFlag(false);
          resetPagesInGrid();
        }}
        clinics={clinics}
        groupId={groupId}
        importType={IMPORT_TYPES.FNPD}
        selectFileTitle={t('DUE_INVOICES.HEADERS.IMPORT_STATEMENT_TYPE_FILE')}
      />
    );
  };

  const getEmrProvider = (): any => {
    if (Array.isArray(userGroups)) {
      const group = userGroups.find((g: any) => {
        return g.id === parseInt(groupId);
      });
      if (group) {
        return group.emr_provider;
      }
    }
    return null;
  };
  const acOfEmrProvider: any = useSelector((state: any) => {
    if (state.clinics.emrProvider) {
      return state.clinics.emrProvider;
    }
    if (Array.isArray(userGroups)) {
      return getEmrProvider();
    }
    return null;
  });

  const renderImportVoucherNumberDialog = () => {
    return (
      <ImportFileDialog
        open={voucherFlag}
        title={t('DUE_INVOICES.VOUCHER_MAPPING_LOCATION')}
        subtitle={t('DUE_INVOICES.VOUCHER_MAPPING_LOCATION_SUBTITLE')}
        onClose={() => {
          setVoucherFlag(false);
          resetPagesInGrid();
        }}
        clinics={clinics}
        groupId={groupId}
        importType={IMPORT_TYPES.VOUCHER_NUMBER}
        selectFileTitle={t('Select File')}
        patientShared={patientShared}
      />
    );
  };

  const guarantorCheckSelect = () => {
    checkBoxes.tableCheckBoxValues.length = 0;
  };

  const handleImportSummary = () => {
    setImportErrorTableFLag(true);
    setSummary({});
    setImportErrorInvoices([]);
    setLastImportedDate('');
    setSelectedLastImportedIds([]);
    if (importErrorTableFLag && acOfClinics.length) {
      getLastImportIds(acOfClinics[0]);
    }
  };

  const renderImportSummaryCloseButton = (): ReactElement => {
    return (
      <div className={'buttons-wrapper button-float-right'}>
        <div className="buttons-wrapper-cover">
          {importErrorTableFLag && (
            <Button
              variant="contained"
              color="primary"
              size={'small'}
              className={['import-error-button-styles'].join(' ')}
              onClick={() => {
                setImportErrorTableFLag(!importErrorTableFLag);
              }}>
              {checkBoxes.loader ? <ImportLoader /> : t('DUE_INVOICES.CLOSE')}
            </Button>
          )}
        </div>
      </div>
    );
  };

  const closeDateTimePicker = (flag: boolean) => {
    setDateTimePicker(false);
    if (flag) {
      setCustomMessageType('');
    }
  };

  const OpenDateTimePicker = () => {
    setDateTimePicker(true);
  };

  const handleClickRemainder = async (event: any, guarantorId: any) => {
    setPopUp(true);
    setRemainderAnchorEl(event.currentTarget);
    setRemainderDates([]);
    const allReminders = await getAllReminders(groupId, guarantorId);
    if (allReminders?.data?.rows?.length > 0) {
      setRemainderDates(allReminders?.data?.rows);
    } else {
      setRemainderDates([]);
    }
  };

  const handleCloseRemainder = () => {
    setPopUp(false);
    // setOpenRemainder(false);
    setRemainderAnchorEl(null);
  };

  const renderDownArrowIcon = (): ReactElement => {
    return (
      <div>
        <DownArrowIcon id="downArrow" name="downArrow" />
      </div>
    );
  };

  const renderUpArrowIcon = (): ReactElement => {
    return (
      <div>
        <UpArrowIcon id="upArrow" name="upArrow" />
      </div>
    );
  };

  const renderNotificationTypeIcon = (type: any): ReactElement => {
    if (!type) {
      return <span />;
    } else if (type === NotificationType.SMS) {
      return (
        <Tooltip title={`${t('NOTIFICATION_TYPE.SMS')}`} placement="top">
          <SmsIcon style={{color: APP.COLOR.PRIMARY}} fontSize={'small'} />
        </Tooltip>
      );
    } else if (type === NotificationType.EMAIL) {
      return (
        <Tooltip title={`${t('NOTIFICATION_TYPE.EMAIL')}`} placement="top">
          <EmailIcon style={{color: APP.COLOR.PRIMARY}} fontSize={'small'} />
        </Tooltip>
      );
    } else {
      return (
        <Tooltip title={`${t('NOTIFICATION_TYPE.OTHER')}`} placement="top">
          <MessageIcon style={{color: APP.COLOR.PRIMARY}} fontSize={'small'} />
        </Tooltip>
      );
    }
  };

  const renderNotificationStatusIcon = (type: any): ReactElement => {
    if (!type) {
      return <span />;
    } else if (type === AppSmsStatus.PENDING) {
      return (
        <Tooltip title={`${t('SMS_STATUSES.PENDING')}`} placement="top">
          <HourglassFullIcon
            style={{color: APP.STATUS.WARNING}}
            fontSize={'small'}
          />
        </Tooltip>
      );
    } else if (type === AppSmsStatus.SENT) {
      return (
        <Tooltip title={`${t('SMS_STATUSES.SENT')}`} placement="top">
          <CheckCircleIcon
            style={{color: APP.STATUS.SUCCESS}}
            fontSize={'small'}
          />
        </Tooltip>
      );
    } else if (type === AppSmsStatus.FAILED) {
      return (
        <Tooltip title={`${t('SMS_STATUSES.FAILED')}`} placement="top">
          <ErrorIcon style={{color: APP.STATUS.ERROR}} fontSize={'small'} />
        </Tooltip>
      );
    } else {
      return (
        <Tooltip title={`${t('SMS_STATUSES.UNKNOWN')}`} placement="top">
          <HelpIcon style={{color: APP.STATUS.DEFAULT}} fontSize={'small'} />
        </Tooltip>
      );
    }
  };

  const renderCardPopUp = (): ReactElement => {
    return (
      <CardPayDialog
        guarantorId={selectedGuarantor.id}
        clinicId={acOfClinics[0]}
        clinicGroupId={groupId}
        guarantorName={HelperUtils.commaSeparatedFullName(
          selectedGuarantor.first_name,
          selectedGuarantor.last_name,
          selectedGuarantor.middle_name
        )}
        guarantorDetails={{
          id: selectedGuarantor.id,
          first_name: selectedGuarantor.first_name,
          last_name: selectedGuarantor.last_name,
          middle_name: selectedGuarantor.middle_name,
          clinic_group_id: selectedGuarantor.clinic_group_id,
          clinic_id: selectedGuarantor.clinic_id,
          email: selectedGuarantor.email,
          address_line_1: selectedGuarantor.address_line_1,
          zip_code: selectedGuarantor.zip_code
        }}
        open={cardPopUpOpen}
        handleClose={reason => {
          if (reason === 'success') {
            resetPagesInGrid(pageNumber);
          }
          closePayPopOver();
          const details = {
            instalment_start_date: null,
            min_instalment_amount: null,
            total_installments: null,
            pay_in_installments_selected: false,
            next_installment_date: null,
            plan_frequency: ''
          };
          dispatch(_resetPaymentsReducer());
          dispatch(_setPayInInstallmentDetails(details));
        }}
        // disableBackdropClick={true}
      />
    );
  };

  const renderRemainderPopper = (): ReactElement => {
    return (
      <Popper
        open={true}
        anchorEl={remainderAnchorEl}
        placement="top-end"
        modifiers={{
          flip: {
            enabled: true
          },
          preventOverflow: {
            enabled: true,
            boundariesElement: 'scrollParent'
          },
          arrow: {
            enabled: false
          }
        }}
        style={{
          position: 'absolute',
          zIndex: 9999,
          width: '20rem',
          overflow: 'hidden',
          border: '1px solid rgba(0, 0, 0, 0.23)',
          borderRadius: '3px',
          background: 'white'
        }}>
        <ClickAwayListener onClickAway={handleCloseRemainder}>
          <div>
            <Typography className={popperClasses.header}>
              {t('DUE_INVOICES.REMAINDER_HEADER')}
            </Typography>
            <Typography className={popperClasses.subTitle}>
              {Array.isArray(remainderDates) && remainderDates.length > 0
                ? t('DUE_INVOICES.REMAINDER_SUB_TITLE')
                : t('DUE_INVOICES.NO_REMINDERS_SENT')}
            </Typography>
            <MenuList className={popperClasses.menuList}>
              {Array.isArray(remainderDates) && remainderDates.length > 0 ? (
                remainderDates.map((obj: any, index: any) => (
                  <div key={index} className={popperClasses.menuItems}>
                    <div
                      className={popperClasses.menuItemsSerial}
                      style={{color: FONT_TERTIARY_COLOR}}>
                      {datesLength - index}
                    </div>
                    <div className={popperClasses.typeWrap}>
                      {renderNotificationTypeIcon(obj.notification_type)}
                    </div>
                    <div>
                      <div className={popperClasses.dataWrap}>
                        <span className={popperClasses.dateWrap}>
                          {HelperUtils.formatDisplayDateTime(obj.reminder_date)}
                        </span>
                        <span className={popperClasses.iconWrap}>
                          {renderNotificationStatusIcon(obj.app_sms_status)}
                        </span>
                      </div>
                      <div className={popperClasses.textWrap}>
                        {obj.failed_reason ? ` ${obj.failed_reason}` : ''}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div />
              )}
            </MenuList>
          </div>
        </ClickAwayListener>
      </Popper>
    );
  };

  const onScrolling = (): void => {
    if (remainderAnchorEl !== null) {
      setRemainderAnchorEl(null);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(resetPagesInGrid, [
    acOfClinics,
    phoneIds,
    selectedNotificationCount,
    selectedStatementDueStatus,
    statementType,
    searchInputRef,
    // minimumAmount,
    // notificationDuration,
    // maximumAmount,
    optOutStatement,
    paymentPlanStatus
  ]);

  const renderConfirmationDialog = () => {
    let reminderType = notificationType();
    reminderType = reminderType.replace(',', ', ');
    return (
      <ConfirmationDialog
        open={confirmDialogOpen}
        onClose={response => {
          if (response === 'confirm') {
            if (!acOfClinics.length) {
              enqueueSnackbar(
                t('DUE_INVOICES.SELECT_A_CLINIC'),
                SnackBarConfig('e')
              );
            } else {
              handleSendRequest(
                false,
                '',
                currentGroup?.send_frequent_notification_guarantor
              );
            }
          }
          setAllInvoices(false);
          setConfirmDialogToAllInvoices(false);
        }}
        title={
          <Trans
            i18nKey={'DUE_INVOICES.SEND_ALL_TITLE'}
            values={{
              label: reminderType,
              filters: combineFilters()
            }}
            components={[<strong key={'X'} />]}
          />
        }
        description={
          <Trans
            i18nKey={'DUE_INVOICES.SELECT_ALL_NOTE'}
            values={{
              clinic: acOfClinicLabels[0],
              filters: combineFilters()
            }}
            components={[<strong key={'X'} />]}
          />
        }
      />
    );
  };

  const renderDueRequestCancelButton = (): ReactElement => {
    return (
      <div className="fields-margin">
        <ButtonField
          onClick={(): void => handleCancelRequest()}
          buttonText={t('DUE_INVOICES.PLACEHOLDERS.CANCEL')}
          className={['cancel-button-styles'].join(' ')}
        />
      </div>
    );
  };

  const renderDialogBox = () => {
    let reminderType = notificationType();
    reminderType = reminderType.replace(',', ', ');

    // 'DUE_INVOICES.SEND_TITLE'
    return (
      <ConfirmationDialog
        open={openDialogBox}
        onClose={response => {
          if (response === 'confirm') {
            handleSendRequest(
              false,
              '',
              currentGroup?.send_frequent_notification_guarantor
            );
          }
          setAllInvoices(false);
          setOpenDialogBox(false);
          // setOpenCustomMessageDialog(openCustomMessageDialog);
          // setCustomMessageType('');
          // setPaymentPlanConfirmDialog(false);
          // setAllInvoices(false);
          // setConfirmDialogToAllInvoices(false);
        }}
        title={
          <Trans
            i18nKey={'DUE_INVOICES.SEND_TITLE'}
            values={{
              label: reminderType,
              filters: combineFilters()
            }}
            components={[<strong key={'X'} />]}
          />
        }
        description={
          <Trans
            i18nKey={'DUE_INVOICES.SELECT_NOTE'}
            values={{
              clinic: acOfClinicLabels[0],
              filters: combineFilters()
            }}
            components={[<strong key={'X'} />]}
          />
        }
      />
    );
  };

  const handleScheduleRequest = (
    event: React.MouseEvent<HTMLElement>
  ): void => {
    if (
      (smsCheck || emailCheck) &&
      (checkBoxes.tableCheckBoxValues.length > 0 || sendToAllInvoices)
    ) {
      setDateTimePicker(true);
    } else {
      if (!smsCheck && !emailCheck) {
        enqueueSnackbar(t('DUE_INVOICES.MESSAGE_TYPE'), SnackBarConfig('e'));
      } else {
        enqueueSnackbar(t('DUE_INVOICES.SELECT_INVOICES'), SnackBarConfig('e'));
      }
    }
  };

  const handleClickToOpen = async () => {
    if (
      (smsCheck || emailCheck) &&
      (checkBoxes.tableCheckBoxValues.length > 0 || sendToAllInvoices) &&
      acOfClinics.length
    ) {
      if (
        checkBoxes.tableCheckBoxValues.length > 0 &&
        Array.isArray(tableRef?.current?.state?.data)
      ) {
        const filterNegativeBalanceDues = tableRef?.current?.state.data.filter(
          (guarantorDueRowData: any) => {
            return (
              checkBoxes.tableCheckBoxValues.includes(guarantorDueRowData.id) &&
              guarantorDueRowData.balance_amount <= 0
            );
          }
        );
        if (
          filterNegativeBalanceDues.length ===
          checkBoxes.tableCheckBoxValues.length
        ) {
          enqueueSnackbar(
            t('DUE_INVOICES.NEGATIVE_BALANCE'),
            SnackBarConfig('e')
          );
          return;
        }
      }
      sendToAllInvoices
        ? setConfirmDialogToAllInvoices(true)
        : setOpenDialogBox(true);
    } else if (!acOfClinics.length) {
      enqueueSnackbar(t('DUE_INVOICES.SELECT_A_CLINIC'), SnackBarConfig('e'));
    } else if (!smsCheck && !emailCheck) {
      enqueueSnackbar(t('DUE_INVOICES.MESSAGE_TYPE'), SnackBarConfig('e'));
    } else {
      enqueueSnackbar(t('DUE_INVOICES.SELECT_INVOICES'), SnackBarConfig('e'));
    }
  };

  const renderScheduleButton = (): ReactElement => {
    // FIXME: hiding the schedule button functionality
    return (
      (Permission.hasStatementPermissions(
        userPermissions,
        AppPermissions.STATEMENT?.SEND_REMINDER,
        groupId
      ) as any) && (
        <div style={{display: 'none'}}>
          <ButtonField
            aria-describedby={'simple-popover'}
            id={'simple-popover'}
            onClick={(event: any): void => handleScheduleRequest(event)}
            buttonText={t('DUE_INVOICES.PLACEHOLDERS.SCHEDULE_SEND')}
            className="select-all-invoices-styles"
          />
        </div>
      )
    );
  };

  const renderSendButton = (): ReactElement => {
    return (
      <div>
        <ButtonField
          onClick={handleClickToOpen}
          buttonText={
            checkBoxes.buttonLoader ? (
              <ButtonLoader />
            ) : (
              t('DUE_INVOICES.PLACEHOLDERS.SEND_NOW')
            )
          }
          className="send-button-styles"
        />
      </div>
    );
  };

  const handleAddMessageAndSendRequest = (type: string, event?: any): void => {
    if (
      (smsCheck || emailCheck) &&
      (checkBoxes.tableCheckBoxValues.length > 0 || sendToAllInvoices) &&
      acOfClinics.length
    ) {
      if (type === CUSTOM_NOTIFICATION_TYPES.CUSTOM_MESSAGE_SEND) {
        setCustomMessageType(type);
        setOpenCustomMessageDialog(!openCustomMessageDialog);
      } else if (
        type === CUSTOM_NOTIFICATION_TYPES.CUSTOM_MESSAGE_SCHEDULE_SEND
      ) {
        setCustomMessageType(type);
        handleScheduleRequest(event);
      }
    } else if (!acOfClinics.length) {
      enqueueSnackbar(t('DUE_INVOICES.SELECT_A_CLINIC'), SnackBarConfig('e'));
    } else if (!smsCheck && !emailCheck) {
      enqueueSnackbar(t('DUE_INVOICES.MESSAGE_TYPE'), SnackBarConfig('e'));
    } else {
      enqueueSnackbar(t('DUE_INVOICES.SELECT_INVOICES'), SnackBarConfig('e'));
    }
  };

  const renderAddMessageAndSendButton = (): ReactElement => {
    return (
      <div data-test-id="pcl-statements-addAndSend">
        <ButtonField
          onClick={() =>
            handleAddMessageAndSendRequest(
              CUSTOM_NOTIFICATION_TYPES.CUSTOM_MESSAGE_SEND
            )
          }
          buttonText={
            checkBoxes.buttonLoader ? (
              <ButtonLoader />
            ) : (
              t('DUE_INVOICES.PLACEHOLDERS.ADD_MESSAGE_AND_SEND')
            )
          }
          className="send-button-styles"
        />
      </div>
    );
  };

  const renderAddMessageAndScheduleButton = (): ReactElement => {
    // FIXME: hiding the schedule button functionality
    return (
      <div style={{display: 'none'}}>
        <ButtonField
          onClick={() =>
            handleAddMessageAndSendRequest(
              CUSTOM_NOTIFICATION_TYPES.CUSTOM_MESSAGE_SCHEDULE_SEND
            )
          }
          buttonText={t('DUE_INVOICES.PLACEHOLDERS.ADD_MESSAGE_AND_SCHEDULE')}
          className="select-all-invoices-styles"
        />
      </div>
    );
  };

  const handleSelectNotificationBatch = (importId: any): void => {
    setSelectedLastImportedIds([importId]);
    getFailedToSaveInvoices(importId.value);
  };

  const handleSmsCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSmsCheck(event.target.checked);
  };

  const handleEmailCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmailCheck(event.target.checked);
  };

  const handleIncludeAllGuarantorCheckBox = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.checked) {
      setAllInvoices(true);
      setCheckBoxesValues({
        ...checkBoxes,
        tableCheckBoxValues: []
      });
      if (typeof tableRef.current?.onAllSelected === 'function') {
        tableRef.current.onAllSelected(false);
      }
    } else {
      setAllInvoices(false);
    }
  };

  const handleRequest = (): void => {
    setRequest(true);
    setCustomMessageRequest(false);
    setOpenDialogBox(false);
  };

  const handleCustomMessageRequest = (): void => {
    setRequest(true);
    setCustomMessageRequest(true);
    setOpenDialogBox(false);
  };

  const renderIncludeAllGuarantorCheckBox = (): ReactElement => {
    return (
      <div
        className={ClinicClasses.renderAllInvoicesButtonsAddOn}
        style={{marginRight: '1.5rem'}}>
        <CheckBoxField
          checked={sendToAllInvoices}
          onChange={handleIncludeAllGuarantorCheckBox}
        />
        <span
          className="check-box-style"
          data-test-id="pcl-statements-allGuarantorInclude">
          {t('DUE_INVOICES.PLACEHOLDERS.SELECT_ALL_INVOICES')}
        </span>
      </div>
    );
  };

  const renderSmsAndEmailCheckBox = (): ReactElement => {
    return (
      <div
        className="check-box-main-view"
        data-test-id="pcl-statements-checkSms">
        <CheckBoxField checked={smsCheck} onChange={handleSmsCheckBox} />
        <div className="check-box-style">
          {t('DUE_INVOICES.PLACEHOLDERS.SMS')}
        </div>
        <div style={{width: '0.2rem'}} />
        <CheckBoxField checked={emailCheck} onChange={handleEmailCheckBox} />
        <div
          className="check-box-style"
          data-test-id="pcl-statements-checkEmail">
          {t('DUE_INVOICES.PLACEHOLDERS.EMAIL')}
        </div>
      </div>
    );
  };

  const renderDueRequestButton = (): ReactElement => {
    return (
      <div className="fields-margin" style={{whiteSpace: 'nowrap'}}>
        <ButtonField
          onClick={(): void => handleRequest()}
          buttonText={t('DUE_INVOICES.PLACEHOLDERS.REQUEST_DUE')}
          className={[
            classes.downloadButtonStyles,
            ClinicClasses.lineHeight
          ].join(' ')}
        />
      </div>
    );
  };

  const renderDownloadInvoicesButtonAction = (): void => {
    allDueInvoices({
      id: groupId,
      clinicId: acOfClinics[0],
      downloadRequest: true,
      sort: {sort: 'first_name', order: 'asc'}
    });
  };

  const renderLastImportIdsFilters = (): ReactElement => {
    return (
      <div className="select-import-id">
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          data-test-id="pcl-statements-selectImportDate"
          value={
            selectedLastImportedIds.length
              ? selectedLastImportedIds.map(batch =>
                  HelperUtils.formatDisplayDateTime(
                    batch.label,
                    BATCH_ID_DATE_FORMAT
                  )
                )
              : [t('PATIENTS.SELECT_IMPORT_ID')]
          }
          variant="outlined"
          onChange={event => {
            event.target.value = selectedLastImportedIds.length
              ? selectedLastImportedIds.map(batch =>
                  HelperUtils.formatDisplayDateTime(
                    batch.label,
                    BATCH_ID_DATE_FORMAT
                  )
                )
              : [t('PATIENTS.SELECT_IMPORT_ID')];
          }}
          fullWidth={true}
          style={
            selectedLastImportedIds.length ? {width: '15rem'} : {opacity: 0.5}
          }
          input={<CustomSelectField />}
          IconComponent={KeyboardArrowDownIcon}
          className="selectView">
          <div className={ClinicClasses.root}>
            <div className={ClinicClasses.ClinicFilterHeader}>
              <Typography style={{fontSize: '1.3rem'}}>
                {t('PATIENTS.IMPORT_ID')}
              </Typography>
              <Button
                className={ClinicClasses.clearAll}
                onClick={clearSelectedLastImportedIds}>
                {t('COMMON.CLEAR_ALL')}
              </Button>
            </div>
            <Divider />
            <div className={ClinicClasses.ClinicMenu}>
              {lastImportedIds.map((batchId: any) => (
                <MenuItem
                  key={batchId.label}
                  value={HelperUtils.formatDisplayDateTime(
                    batchId.label,
                    BATCH_ID_DATE_FORMAT
                  )}
                  onClick={(): void => handleSelectNotificationBatch(batchId)}>
                  <ListItemText
                    className={[ClinicClasses.primary].join(' ')}
                    primary={HelperUtils.formatDisplayDateTime(
                      batchId.label,
                      BATCH_ID_DATE_FORMAT
                    )}
                  />
                  <Radio
                    checked={
                      !!selectedLastImportedIds.find(
                        _batchId => _batchId.value === batchId.value
                      )
                    }
                  />
                </MenuItem>
              ))}
            </div>
          </div>
        </Select>
      </div>
    );
  };

  const isAnyFilterApplied =
    (searchInputRef.current as any)?.value?.length > 2 ||
    !!phoneIds.length ||
    !!selectedNotificationCount.length ||
    !!selectedStatementDueStatus.length ||
    !!minimumAmount.length ||
    !!notificationDuration.length ||
    !!maximumAmount.length ||
    !!optOutStatement.length ||
    !!statementType ||
    !!paymentPlanStatus?.value;

  // THIS STATE ONLY STORE THE LATEST IMPORT SUMMARY THAT WILL BE DISPLAYED WHEN THE CLINIC ID IS SELECTED AND THERE IS NO FILTER APPLIED.
  // THERE IS ANOTHER STATE WITH NAME SIMILAR TO THIS ONE. THAT IS USED TO STORE IMPORT SUMMARY IN IMPORT HISTORY SCREEN.
  const [latestImportSummary, setLatestImportSummary] = useState({
    data: null as any,
    importId: null as any,
    isLoading: false
  });

  useEffect(() => {
    const fetchLatestSummary = async ({clinicId}: {clinicId: number}) => {
      try {
        setLatestImportSummary(p => ({
          ...p,
          isLoading: true
        }));
        const importIdsRes: any = await getImportSummaryImportIds(
          groupId,
          ImportSummaryTypes.INVOICE,
          clinicId
        );
        const importIds = importIdsRes?.data;
        if (Array.isArray(importIds) && importIds.length > 0) {
          const latestImportId = importIds[0];
          const latestSummaryRes: any = await getImportErrorData(
            groupId,
            ImportSummaryTypes.INVOICE,
            latestImportId?.value,
            acOfClinics[0]
          );
          setLatestImportSummary(p => ({
            ...p,
            data: latestSummaryRes?.data?.report_data,
            importId: latestImportId,
            isLoading: false
          }));
        } else {
          setLatestImportSummary({
            data: null,
            importId: null,
            isLoading: false
          });
        }
      } catch (err: any) {
        if (err?.message) enqueueSnackbar(err.message, SnackBarConfig('e'));
        setLatestImportSummary({
          data: null,
          importId: null,
          isLoading: false
        });
      }
    };
    if (acOfClinics?.[0] && !isAnyFilterApplied) {
      fetchLatestSummary({
        clinicId: acOfClinics[0]
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAnyFilterApplied, acOfClinics?.[0], groupId]);

  if (showFnPdCheck) {
    return (
      <div
        className={['due-invoices-wrapper', classes.gridWrapper].join(' ')}
        onScroll={(): void => onScrolling()}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'inherit',
            overflow: 'auto'
          }}>
          <CheckStatements
            goBack={() => {
              setFnPdCheckView(false);
            }}
          />
        </div>
      </div>
    );
  }
  const setShowEmptyTableHandler = () => {
    setShowEmptyTable(false);
  };

  const renderValue = ({value}: {value?: string | number}) => {
    const charLimitOnOldAndNewValues = 55;

    if (!value) {
      return t('COMMON.NONE_VALUE');
    }
    if (value.toString().length <= charLimitOnOldAndNewValues) {
      return value;
    }
    return (
      <>
        {value.toString().slice(0, charLimitOnOldAndNewValues)}
        {'... '}
        <span
          onClick={() => {
            setShowMoreDetails({
              open: true,
              title: '',
              value: value.toString()
            });
          }}
          className="link-text-style">
          {t('TICKETING_SYSTEM.MORE_DETAILS')}
        </span>
      </>
    );
  };

  return (
    <div
      className={['due-invoices-wrapper', classes.gridWrapper].join(' ')}
      onScroll={(): void => onScrolling()}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'inherit',
          overflow: 'auto'
        }}>
        {!importErrorTableFLag ? (
          <div className="patientsStatementFilterWrapper">
            <div className={'header-section-wrapper'}>
              {/* <HelperTexts
                title={t('DUE_INVOICES.TITLE')}
                subTitle={t('DUE_INVOICES.SUBTITLE')}
              /> */}
            </div>
            <PatientStatementsFilterComponent
              page={1}
              handleImportSummary={handleImportSummary}
              handleImportStatementBoolean={setImportFlag}
              handleImportFNPDBoolean={setImportStatementTypeFlag}
              setStatementType={setStatementType}
              searchInputRef={searchInputRef}
              statementType={statementType}
              phoneIds={phoneIds}
              setPhoneIds={setPhoneIds}
              setSelectedNotificationCount={setSelectedNotificationCount}
              selectedNotificationCount={selectedNotificationCount}
              selectedStatementDueStatus={selectedStatementDueStatus}
              setStatementDueStatus={setStatementDueStatus}
              setEmailCheck={setEmailCheck}
              renderSearchFiled={renderSearchFiled}
              guarantorCheckSelect={guarantorCheckSelect}
              renderClinicFilters={renderClinicFilters}
              renderDueRequestButton={renderDueRequestButton}
              request={request}
              renderIncludeAllGuarantorCheckBox={
                renderIncludeAllGuarantorCheckBox
              }
              renderSmsAndEmailCheckBox={renderSmsAndEmailCheckBox}
              renderSendButton={renderSendButton}
              renderScheduleButton={renderScheduleButton}
              renderDueRequestCancelButton={renderDueRequestCancelButton}
              renderDownloadInvoicesButtonAction={
                renderDownloadInvoicesButtonAction
              }
              resetPagesInGrid={resetPagesInGrid}
              showFnPdList={() => {
                setFnPdCheckView(true);
              }}
              selectedClinic={acOfClinics}
              clinicsList={clinics}
              handleSendStatements={() => {
                handleRequest();
              }}
              handleCustomMessages={() => {
                handleCustomMessageRequest();
              }}
              customMessageRequest={customMessageRequest}
              renderAddMessageAndSendButton={renderAddMessageAndSendButton}
              renderAddMessageAndScheduleButton={
                renderAddMessageAndScheduleButton
              }
              handleSetFlag={() => {
                setShowEmptyTableHandler();
              }}
              minimumAmount={minimumAmount}
              notificationDuration={notificationDuration}
              setNotificationDuration={setNotificationDuration}
              maximumAmount={maximumAmount}
              setMaximumAmount={setMaximumAmount}
              setMinimumAmount={setMinimumAmount}
              setOptOutStatement={setOptOutStatement}
              selectedOptOutStatement={optOutStatement}
              handleImportsetVoucherFlag={setVoucherFlag}
              acOfEmrProvider={acOfEmrProvider}
              paymentPlanStatus={paymentPlanStatus}
              setPaymentPlanStatus={setPaymentPlanStatus}
              currentGroup={currentGroup}
            />
          </div>
        ) : (
          ''
        )}
        {importErrorTableFLag && (
          <div className="due-search-filters-main-view">
            <div className="import-summary-header-section-wrapper">
              <HelperTexts
                title={
                  !importErrorTableFLag
                    ? t('DUE_INVOICES.TITLE')
                    : t('DUE_INVOICES.PENDING_IMPORT_SUMMARY')
                }
                subTitle={
                  !importErrorTableFLag
                    ? t('DUE_INVOICES.SUBTITLE')
                    : t('DUE_INVOICES.PENDING_IMPORT_SUMMARY_SUBTITLE')
                }
              />
            </div>
            <div className="flex-view">
              {renderClinicFilters()}
              {renderLastImportIdsFilters()}
              {
                <div className={importSummaryStyle.lastImported}>
                  {lastImportedDate && (
                    <>
                      <span className={importSummaryStyle.lastImportedLabel}>
                        {t('DUE_INVOICES.IMPORT_SUMMARY.LAST_IMPORTED_ON')}:
                      </span>
                      <span className={importSummaryStyle.lastImportedVal}>
                        {HelperUtils.formatDisplayDateTime(lastImportedDate)}
                        {renderValue({
                          value: `  (${t('COMMON.UPLOADED_BY')}: ${
                            selectedLastImportedIds[0]?.created_by || '-'
                          })`
                        })}
                      </span>
                    </>
                  )}
                </div>
              }
              {renderImportSummaryCloseButton()}
            </div>
            {importErrorTableFLag &&
              acOfClinics.length &&
              renderImportSummary(summary)}
          </div>
        )}
        {!importErrorTableFLag ? (
          !loader ? (
            acOfClinics.length ? (
              isAnyFilterApplied ? (
                <GridTable
                  columns={[
                    {
                      title: t('DUE_INVOICES.TABLE_HEAD.GUARANTOR'),
                      field: 'guarantor_name',
                      cellStyle: {
                        ...GuarantorCellStyle
                      },
                      headerStyle: {
                        ...GuarantorHeaderStyle
                      },
                      render: (rowData: any) => (
                        <div>
                          <div
                            className={[
                              classes.primaryTextColor,
                              classes.displayFlex,
                              ClinicClasses.gridText
                            ].join(' ')}>
                            <div
                              data-test-id="pcl-statements-guarantorName"
                              className={[
                                classes.patientNameStyles,
                                ClinicClasses.gridText
                              ].join(' ')}
                              onClick={(e): Promise<any> => {
                                e.stopPropagation();
                                if (
                                  Permission.hasPatientPermissions(
                                    userPermissions,
                                    AppPermissions.PAYMENT_HISTORY.LIST,
                                    groupId
                                  ) as any
                                ) {
                                  return openGuarantorDrawer(
                                    HelperUtils.commaSeparatedFullName(
                                      rowData.first_name,
                                      rowData.last_name,
                                      rowData.middle_name
                                    ),
                                    rowData.id
                                  );
                                }
                                return new Promise(resolve => resolve(''));
                              }}>
                              {HelperUtils.commaSeparatedFullName(
                                rowData.first_name,
                                rowData.last_name,
                                rowData.middle_name
                              )}
                            </div>
                            {(rowData.due_notice_type ===
                              StatementNoticeType.FN.key ||
                              rowData.due_notice_type ===
                                StatementNoticeType.PD.key) && (
                              <span
                                className={[
                                  classes.tagsGuarantor,
                                  rowData.due_notice_type ===
                                  StatementNoticeType.FN.key
                                    ? classes.tagsGuarantorFn
                                    : '',
                                  rowData.due_notice_type ===
                                  StatementNoticeType.PD.key
                                    ? classes.tagsGuarantorPd
                                    : ''
                                ].join(' ')}>
                                {rowData.due_notice_type ===
                                StatementNoticeType.FN.key
                                  ? StatementNoticeType.FN.label
                                  : StatementNoticeType.PD.label}
                              </span>
                            )}
                          </div>
                          {clinicEmrProvider != '3' && (
                            <div
                              style={{marginTop: '3px'}}
                              data-test-id="pcl-statements-guarantorAccountNumber">
                              {t('DUE_INVOICES.ACCOUNT_NUMBER', {
                                account_number: rowData.emr_id
                              })}
                            </div>
                          )}
                        </div>
                      )
                    },
                    {
                      title: t('DUE_INVOICES.TABLE_HEAD.NOTIFICATION_PHONE'),
                      field: 'notification_phone',
                      cellStyle: {
                        ...phoneNumberWidth,
                        whiteSpace: 'nowrap',
                        paddingLeft: '10px'
                      },
                      headerStyle: {
                        position: 'sticky',
                        paddingRight: '0px',
                        paddingLeft: '0px',
                        whiteSpace: 'nowrap'
                      },
                      render: (rowData: any) => (
                        <div
                          data-test-id="pcl-statements-notificationPhone"
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'start',
                            position: 'relative',
                            right: '12px'
                          }}>
                          <div>
                            {rowData.notification_phone ? (
                              <PhoneNumberFormatter
                                value={rowData.notification_phone}
                              />
                            ) : (
                              '—'
                            )}
                          </div>
                          {(Permission.hasPatientPermissions(
                            userPermissions,
                            AppPermissions.PATIENT.EDIT_NOTIFICATION_PHONE,
                            groupId
                          ) as any) && (
                            <div
                              className={ClinicClasses.edit}
                              data-test-id="pcl-statements-editNotificationPhone">
                              {
                                <Tooltip
                                  title={
                                    rowData.notification_phone &&
                                    rowData.notification_phone.length > 0
                                      ? t(
                                          'DUE_INVOICES.EDIT_NOTIFICATION_PHONE'
                                        ).toString()
                                      : t(
                                          'DUE_INVOICES.ADD_NOTIFICATION_PHONE'
                                        ).toString()
                                  }>
                                  <div>
                                    <Link
                                      className="action"
                                      onClick={(e: any) => {
                                        openPhonePopOver(rowData);
                                        e.stopPropagation();
                                      }}>
                                      {rowData.notification_phone &&
                                      rowData.notification_phone.length > 0
                                        ? t('DUE_INVOICES.EDIT')
                                        : t('DUE_INVOICES.ADD')}
                                    </Link>
                                  </div>
                                </Tooltip>
                              }
                            </div>
                          )}

                          {(Permission.hasIncomingSmsPermissions(
                            userPermissions,
                            AppPermissions.INCOMING_SMS.REPLY,
                            groupId
                          ) as any) &&
                            rowData.notification_phone?.length > 0 && (
                              <div
                                className={ClinicClasses.edit}
                                data-test-id="pcl-statements-sendMessageNotificationPhone">
                                {
                                  <Tooltip
                                    title={t(
                                      'DUE_INVOICES.SEND_MESSAGE'
                                    ).toString()}>
                                    <div>
                                      <Link
                                        className="action"
                                        onClick={(e: any) => {
                                          onSendMessageClick(rowData);
                                          e.stopPropagation();
                                        }}>
                                        {t('DUE_INVOICES.SEND_MESSAGE')}
                                      </Link>
                                    </div>
                                  </Tooltip>
                                }
                              </div>
                            )}
                        </div>
                      )
                    },
                    {
                      title: t('DUE_INVOICES.TABLE_HEAD.DUE_AMOUNT'),
                      field: 'due_amount',
                      render: (rowData: any) => (
                        <div data-test-id="pcl-statements-dueAmount">
                          <CurrencyFormatter
                            value={rowData.guarantor_due || '0'}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                            ignoreRound={true}
                            useSign={true}
                          />
                        </div>
                      ),
                      cellStyle: {
                        ...tableCellWidth8,
                        textAlign: 'right',
                        paddingRight: '27px'
                      },
                      headerStyle: {
                        textAlign: 'right',
                        position: 'sticky',
                        left: '12px',
                        padding: 0
                      }
                    },
                    {
                      title: t('DUE_INVOICES.TABLE_HEAD.BALANCE_FORWARD'),
                      field: 'due_amount',
                      render: (rowData: any) => (
                        <div data-test-id="pcl-statements-balanceForward">
                          <CurrencyFormatter
                            value={rowData.balance_forward || '0'}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                            ignoreRound={true}
                            useSign={true}
                          />
                        </div>
                      ),
                      cellStyle: {
                        ...tableCellWidth8,
                        textAlign: 'right',
                        paddingRight: '27px'
                      },
                      headerStyle: {
                        textAlign: 'right',
                        position: 'sticky',
                        left: '12px',
                        padding: 0
                      }
                    },
                    {
                      title: t('DUE_INVOICES.TABLE_HEAD.PAID_AMOUNT'),
                      field: 'amount_paid',
                      render: (rowData: any) => (
                        <div data-test-id="pcl-statements-paidAmount">
                          <CurrencyFormatter
                            value={rowData.amount_paid || '0'}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                            ignoreRound={true}
                            useSign={true}
                          />
                        </div>
                      ),
                      cellStyle: {
                        ...tableCellWidth12,
                        textAlign: 'right',
                        paddingRight: '42px'
                      },
                      headerStyle: {
                        textAlign: 'right',
                        position: 'sticky',
                        left: '27px',
                        paddingLeft: '0px'
                      }
                    },
                    {
                      title: t('DUE_INVOICES.TABLE_HEAD.REMAINING_BALANCE'),
                      field: 'balance_amount',
                      render: (rowData: any) => (
                        <div
                          style={{display: 'flex', flexDirection: 'column'}}
                          data-test-id="pcl-statements-remainingBalance">
                          <CurrencyFormatter
                            value={rowData.balance_amount}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                            ignoreRound={true}
                            useSign={true}
                          />
                          {Permission.hasStatementPermissions(
                            userPermissions,
                            AppPermissions.STATEMENT.PAY,
                            groupId
                          ) &&
                            Permission.hasPaymentHistoryPermissions(
                              userPermissions,
                              AppPermissions.PAYMENT_HISTORY.LIST,
                              groupId
                            ) && (
                              <div data-test-id="pcl-statements-takePayment">
                                <Tooltip
                                  title={`Pay for
                          ${HelperUtils.commaSeparatedFullName(
                            rowData.first_name,
                            rowData.last_name,
                            rowData.middle_name
                          )}`}>
                                  <Link
                                    component="button"
                                    style={{
                                      textAlign: 'right',
                                      whiteSpace: 'nowrap',
                                      fontSize: '0.925rem'
                                    }}
                                    variant="body2"
                                    onClick={(e: any): void => {
                                      openPayPopOver(rowData);
                                      e.stopPropagation();
                                    }}>
                                    {t('DUE_INVOICES.PAY')}
                                  </Link>
                                </Tooltip>
                                <Tooltip
                                  title={`Share Payment URL to
                              ${HelperUtils.commaSeparatedFullName(
                                rowData.first_name,
                                rowData.last_name,
                                rowData.middle_name
                              )}`}>
                                  <Link
                                    component="button"
                                    style={{
                                      textAlign: 'right',
                                      whiteSpace: 'nowrap',
                                      fontSize: '0.925rem'
                                    }}
                                    variant="body2"
                                    onClick={(e: any): void => {
                                      openEmailPopOver(rowData);
                                      e.stopPropagation();
                                    }}>
                                    {t('DUE_INVOICES.SHARE_PAYMENT_LINK')}
                                    {/* {t('SHOW_PAYMENT_URL_DIALOG.SHOW')} */}
                                  </Link>
                                </Tooltip>
                              </div>
                            )}
                        </div>
                      ),
                      cellStyle: {
                        ...tableCellWidth12,
                        textAlign: 'right',
                        paddingRight: '42px'
                      },
                      headerStyle: {
                        textAlign: 'right',
                        position: 'sticky',
                        left: '27px',
                        paddingLeft: '0px'
                      }
                    },
                    {
                      title: t('DUE_INVOICES.HEADERS.NOTIFICATIONS'),
                      sorting: false,
                      field: 'reminder_date',
                      render: (rowData: any) => {
                        const notificationInfo = getGuarantorNotificationInfo(
                          rowData?.id
                        );
                        return (
                          <div
                            className={classes.displayFlexColumn}
                            data-test-id="pcl-statements-notifications">
                            {guarantorNotificationInfo.isLoading ? (
                              <Loader size={16} />
                            ) : (
                              <>
                                <div className={popperClasses.notificationView}>
                                  {[
                                    <div key={'notification_count'}>
                                      {t('DUE_INVOICES.SENT')}:
                                      {notificationInfo?.notification_count ??
                                        0}
                                    </div>,
                                    parseInt(
                                      notificationInfo?.notification_count ?? 0
                                    ) != 0 && (
                                      <Tooltip
                                        title={
                                          t(
                                            'DUE_INVOICES.NOTIFICATION_HISTORY'
                                          ) as string
                                        }
                                        key={'history_icon'}>
                                        <div
                                          id={rowData.id}
                                          className={
                                            popperClasses.notificationReminder
                                          }
                                          onClick={e => {
                                            handleClickRemainder(e, rowData.id);
                                            e.stopPropagation();
                                          }}>
                                          <RemainderHistory />
                                        </div>
                                      </Tooltip>
                                    )
                                  ]}
                                </div>
                                {parseInt(
                                  notificationInfo?.notification_count ?? 0
                                ) != 0 && (
                                  <p>
                                    {t('DUE_INVOICES.LAST_SENT_ON')}:{' '}
                                    {notificationInfo?.reminder_date
                                      ? HelperUtils.formatDisplayDate(
                                          notificationInfo?.reminder_date
                                        )
                                      : '-'}
                                  </p>
                                )}
                              </>
                            )}
                          </div>
                        );
                      },
                      cellStyle: {
                        ...GuarantorCellStyle
                      }
                    },

                    {
                      title: t(
                        'PATIENT_DETAILS_CARD.OPTED_OUT_ELECTRONIC_STATEMENTS'
                      ),
                      sorting: false,
                      field: 'opt_out_electronic_statements',
                      render: (rowData: any) => {
                        const notificationInfo = getGuarantorNotificationInfo(
                          rowData?.id
                        );
                        return (
                          <div
                            className={classes.displayFlexColumn}
                            data-test-id="pcl-statements-optedOut">
                            {guarantorNotificationInfo.isLoading ? (
                              <Loader size={16} />
                            ) : (
                              <div>
                                {notificationInfo?.opt_out_electronic_statements
                                  ? formOptedOutNotificationLabel(
                                      notificationInfo?.opt_out_electronic_statements
                                    )
                                  : t(
                                      'PATIENT_DETAILS_CARD.NOT_OPTED_OUT_ELECTRONIC_STATEMENTS'
                                    )}
                              </div>
                            )}
                          </div>
                        );
                      },
                      cellStyle: {
                        ...phoneNumberWidth
                      },
                      headerStyle: {
                        whiteSpace: 'nowrap'
                      }
                    },

                    {
                      title: '',
                      field: '',
                      cellStyle: {
                        ...GuarantorCellStyle
                      },
                      headerStyle: {
                        ...GuarantorHeaderStyle
                      },
                      render: (rowData: any) =>
                        (Permission.hasStatementPermissions(
                          userPermissions,
                          AppPermissions.STATEMENT?.UPDATE_FNPD,
                          groupId
                        ) as any) && (
                          <div
                            className="filters-view"
                            data-test-id="pcl-statements-actionsButton">
                            <Tooltip
                              title={t(
                                'DUE_INVOICES.PLACEHOLDERS.ACTIONS'
                              ).toString()}>
                              <IconButton
                                aria-controls="customized-menu"
                                aria-haspopup="true"
                                color="inherit"
                                onClick={event => {
                                  handleToggleStatementType(event, rowData);
                                  event.stopPropagation();
                                }}>
                                <MoreVertIcon />
                              </IconButton>
                            </Tooltip>
                          </div>
                        )
                    }
                  ]}
                  tableRef={tableRef}
                  onRowClick={(event: any, rowData: any, togglePanel) => {
                    togglePanel?.();
                  }}
                  data={query => {
                    setPageNum(query.page);
                    return new Promise((resolve, reject) => {
                      if (acOfClinics[0]) {
                        allDueInvoices({
                          id: groupId,
                          clinicId: acOfClinics[0],
                          searchText: (searchInputRef.current as any).value,
                          resetFilters: undefined,
                          limit: query.pageSize,
                          offset: query.page * query.pageSize,
                          sort: {
                            sort: query.orderBy?.field
                              ? query.orderBy.field.toString()
                              : '',
                            order: query.orderDirection
                          }
                        })
                          .then((res: any) => {
                            if (showEmptyTable) {
                              resolve({
                                data: [],
                                page: 0,
                                totalCount: 0
                              });
                            } else {
                              // checking whether the page is having records or not and if records are not present navigating back to previous page
                              const pageNumberQuery = query.page;
                              if (
                                res?.data?.rows.length === 0 &&
                                pageNumberQuery > 0
                              ) {
                                resetPagesInGrid(pageNumberQuery - 1);
                                reject();
                              }
                              if (res?.data?.rows) {
                                resolve({
                                  data: res.data.rows,
                                  page: pageNumberQuery,
                                  totalCount: parseInt(res.data.count)
                                });
                              } else {
                                resolve({
                                  data: [],
                                  page: 0,
                                  totalCount: 0
                                });
                              }
                            }
                          })
                          .catch(() => {
                            reject();
                          });
                      } else {
                        resolve({
                          data: [],
                          page: query.page,
                          totalCount: 0
                        });
                      }
                    });
                  }}
                  localization={{
                    body: {
                      emptyDataSourceMessage: showEmptyTable
                        ? t('DUE_INVOICES.MESSAGE')
                        : acOfClinics.length
                        ? t('DUE_INVOICES.NO_RECORDS')
                        : t('DUE_INVOICES.SELECT_A_CLINIC')
                    },
                    pagination: {
                      labelDisplayedRows: t('DUE_INVOICES.GRID_PAGINATION', {
                        patientCount
                      })
                    }
                  }}
                  options={{
                    ...DEFAULT_GRID_TABLE__OPTIONS,
                    paging: invoices?.length > 0,
                    emptyRowsWhenPaging: false,
                    sorting: true,
                    pageSize: PAGINATION_SIZE.DUE_INVOICES,
                    pageSizeOptions: PAGINATION_SIZE_OPTIONS,
                    showEmptyDataSourceMessage: true,
                    maxBodyHeight: '100%',
                    actionsColumnIndex: -1,
                    tableLayout: 'auto',
                    detailPanelColumnAlignment: 'left',
                    selection: request && !sendToAllInvoices,
                    draggable: false,
                    showSelectAllCheckbox: request,
                    headerStyle: {
                      color: DEFAULT_BLACK_COLOR,
                      fontFamily: APP.FONT_FAMILY.MEDIUM,
                      flexDirection: 'row',
                      zIndex: 100
                    }
                  }}
                  onSelectionChange={rows => {
                    handleTableCheckBoxes(rows);
                  }}
                  detailPanel={[
                    {
                      tooltip: t('DUE_INVOICES.VIEW_PATIENTS'),
                      icon: renderDownArrowIcon,
                      openIcon: renderUpArrowIcon,
                      render: (rowData: any) => {
                        // ** Passing guarantorId to the toggle grid table to fetch the invoices details */
                        return (
                          <GuarantorInvoicesTable guarantorId={rowData?.id} />
                        );
                      }
                    }
                  ]}
                  style={{
                    margin: '0rem 2rem 5rem',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'auto',
                    boxShadow:
                      '0 0 0 1px rgb(63 63 68 / 5%), 0 1px 3px 0 rgb(63 63 68 / 15%)'
                  }}
                />
              ) : (
                <div
                  className={[
                    ClinicClasses.tableContainer,
                    ClinicClasses.emptyTableWithSummary
                  ].join(' ')}>
                  <div style={{marginTop: '1rem'}}>
                    {t('DUE_INVOICES.APPLY_ANY_FILTER')}
                  </div>
                  <div className="latest-import-summary-wrapper">
                    {latestImportSummary.isLoading && (
                      <Loader size={24} style={{marginBottom: '1rem'}} />
                    )}
                    {!latestImportSummary.isLoading &&
                      latestImportSummary.data && (
                        <div>
                          <Divider />
                          <p className="summary-title">
                            {t('DUE_INVOICES.LATEST_IMPORT_SUMMARY_LABEL')}
                          </p>
                          <p>
                            {t('DUE_INVOICES.DATE_OF_IMPORT_LABEL')}:{' '}
                            {HelperUtils.formatDisplayDateTime(
                              latestImportSummary.importId?.label,
                              BATCH_ID_DATE_FORMAT
                            )}
                          </p>
                          {renderImportSummary(latestImportSummary.data)}
                        </div>
                      )}
                  </div>
                </div>
              )
            ) : (
              <div
                className={[
                  ClinicClasses.tableContainer,
                  ClinicClasses.emptyTableStyle
                ].join(' ')}>
                <div style={{marginTop: '1rem'}}>
                  {t('COMMON.SELECT_PRACTICE_FILTER')}
                </div>
              </div>
            )
          ) : (
            <div
              style={{
                width: '100%',
                height: '500px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
              <Loader />
            </div>
          )
        ) : (
          <InvoiceImportErrorTable
            invoices={importErrorInvoices}
            clinicName={failedInvoicesClinic}
            clinicId={acOfClinics[0]}
          />
        )}
        {popUp && renderRemainderPopper()}

        {/* {open && (
          <DrawerComponent
            closeDrawer={closeDrawer}
            patientName={patientName}
            balanceDue={balanceDue}
            serviceData={invoiceLinesData}
          />
        )} */}

        {guarantorValues?.guarantorDrawerOpen && (
          <GuarantorDrawerComponent
            open={guarantorValues?.guarantorDrawerOpen}
            closeDrawer={closeGuarantorDrawer}
            guarantorId={guarantorValues?.guarantorId}
            guarantorName={guarantorValues?.guarantorName}
            resetPagesInGrid={resetPagesInGrid}
          />
        )}
        {openDateTimePicker && (
          <CustomDateTimePicker
            // @ts-ignore
            close={(closeFlag: boolean) => closeDateTimePicker(closeFlag)}
            open={OpenDateTimePicker}
            handleSendRequest={handleSendRequest}
            checkBoxes={checkBoxes}
            reminderType={getReminderType()}
            clinicId={acOfClinics[0]}
            selectAll={sendToAllInvoices}
            dueType={statementType}
            selectedNotificationCount={selectedNotificationCount}
            scheduleType={customMessageType}
            handleCustomMessageDialog={() => {
              setCustomMessageType(
                CUSTOM_NOTIFICATION_TYPES.CUSTOM_MESSAGE_SCHEDULE_SEND
              );
              setOpenCustomMessageDialog(true);
            }}
          />
        )}
        {confirmDialogOpen && renderConfirmationDialog()}
        {confirmDialogOpenForNoticeType &&
          renderConfirmationForUpdateStatementType()}
        {openDialogBox && renderDialogBox()}
        {renderPopover()}
        {importFlag && renderImportDialog()}
        {importStatementTypeFlag && renderImportStatementTypeDialog()}
        {acOfEmrProvider === EMRProviderIDs.ALL_SCRIPT_V2 &&
          voucherFlag &&
          renderImportVoucherNumberDialog()}
        {phonePopOver && (
          <ChangePhoneDialog
            title={
              <Trans
                i18nKey={'DUE_INVOICES.NOTIFICATION_DIALOG.HEADING'}
                values={{
                  // guarantorName: selectedGuarantor.name
                  guarantorName: HelperUtils.commaSeparatedFullName(
                    selectedGuarantor.first_name,
                    selectedGuarantor.last_name,
                    selectedGuarantor.middle_name
                  )
                }}
                components={[<strong key={'X'} />]}
              />
            }
            subtitle={t('DUE_INVOICES.NOTIFICATION_DIALOG.TITLE')}
            open={phonePopOver}
            onClose={(): void => {
              setPhonePopOver(false);
              setSelectedGuarantor(null);
              setCheckBoxesValues({
                ...checkBoxes,
                buttonLoader: false,
                tableCheckBoxValues: []
              });
              resetPagesInGrid(pageNumber);
            }}
            groupId={groupId}
            selectedGuarantor={selectedGuarantor}
            clinicId={acOfClinics[0]}
            showSendRemainder={
              Permission.hasStatementPermissions(
                userPermissions,
                AppPermissions.STATEMENT?.SEND_REMINDER,
                groupId
              ) as any
            }
          />
        )}
      </div>
      {emailPopOver && (
        <SharePaymentDialog
          open={emailPopOver}
          onClose={closeEmailPopOver}
          title={
            <Trans
              i18nKey={'DUE_INVOICES.EMAIL_DIALOG.SHARE_PAYMENT_HEADING'}
              values={{
                // guarantorName: selectedGuarantor.name
                guarantorName: HelperUtils.commaSeparatedFullName(
                  selectedGuarantor.first_name,
                  selectedGuarantor.last_name,
                  selectedGuarantor.middle_name
                )
              }}
              components={[<strong key={'X'} />]}
            />
          }
          subtitle={
            <Trans
              i18nKey={'DUE_INVOICES.EMAIL_DIALOG.SHARE_PAYMENT_SUBTITLE'}
              values={{
                amount: getFormattedValue(
                  selectedGuarantor.balance_amount,
                  true
                ),
                clinicName: acOfClinicLabels[0],
                guarantorName: HelperUtils.commaSeparatedFullName(
                  selectedGuarantor.first_name,
                  selectedGuarantor.last_name,
                  selectedGuarantor.middle_name
                )
              }}
              components={[<strong key={'X'} />]}
            />
          }
          groupId={groupId}
          selectedGuarantor={selectedGuarantor}
          clinicId={acOfClinics[0]}
        />
      )}
      {/* payPopOver && (
        <Modal
          open={payPopOver}
          onClose={closeEmailPopOver}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          disableBackdropClick={true}>
          {renderCardDetailsForm()}
        </Modal>
      ) */}
      {cardPopUpOpen && renderCardPopUp()}

      {openCustomMessageDialog && (
        <CustomMessageDialog
          open={openCustomMessageDialog}
          title={t('DUE_INVOICES.CUSTOM_MESSAGES.TITLE')}
          subtitle={t('DUE_INVOICES.CUSTOM_MESSAGES.SUBTITLE')}
          handleCancel={() => {
            setOpenCustomMessageDialog(!openCustomMessageDialog);
            setCustomMessageType('');
          }}
          // handleOpen={() => {
          //   setOpenCustomMessageDialog(openCustomMessageDialog);
          // }}
          groupId={groupId}
          sendNotification={(
            salutation: boolean,
            message: string,
            sendNotification: boolean
          ) => {
            handleSendRequest(salutation, message, sendNotification);
            setOpenCustomMessageDialog(!openCustomMessageDialog);
            setCustomMessageType('');
          }}
          reminderType={notificationType()}
          setSendStatementsPaymentPlan={setSendStatementsPaymentPlan}
          type={SendCustomMessageTypes.STATEMENT}
          confirmDialogTitle={'DUE_INVOICES.SEND_TITLE'}
          confirmDialogSubTitle={'DUE_INVOICES.SELECT_NOTE'}
          currentGroup={currentGroup}
          setOpenCustomMessageDialog={setOpenCustomMessageDialog}
          openCustomMessageDialog={openCustomMessageDialog}
        />
      )}
      {showConversation && renderConversationsDialog()}
      {showMoreDetails.open && (
        <CCMShowFullNotesDialog
          open={showMoreDetails.open}
          onClose={() => {
            setShowMoreDetails({
              open: false,
              title: '',
              value: ''
            });
           }}
          notes={showMoreDetails.value}
          title={showMoreDetails.title}
        />
      )}
    </div>
  );
};

function mapStateToProps(state: any): any {
  return {
    groupId: state.auth.groupId,
    scheduleSendDate: state.payments.scheduleSendDate,
    selectedClinicId: state.clinics.selectedClinicId,
    selectedClinicLabel: state.clinics.selectedClinicLabel,
    userPermissions: state.auth.userPermissions,
    clinicNotificationBatches: state.clinics.clinicNotificationBatches,
    patientShared: state.clinics.patientShared
  };
}

export default connect(mapStateToProps, {
  _statementsSelectedClinic,
  _guarantorLogin,
  _saveClinicDetails,
  _guarantorPayAmount,
  _guarantorPayCashAmount,
  _clinicNotificationBatchIds,
  _updatePaymentType
})(DueInvoices);
